import React, { useState, useEffect } from "react";
import { StoreContext } from "../context/StoreContext";

import {
    TextField,
    Box,
    Button,
    Grid,
    FormControl,
    FormHelperText,
    Typography,
    Snackbar,
    Switch,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    InputAdornment,
    CircularProgress,
    Backdrop,
    MenuItem,
    DialogContentText,
    DialogActions,
    Chip,
    Divider,
    useTheme
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import { AddressEntryTextBox } from "../components/address/AddressEntryTextBox";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
import { useStyles } from "../styles/MainNavbarStyles";
import { useCompanyStyles } from "../styles/CompanyFormStyles";
import {
    graphql,
    graphqlOperation,
    postApi,
    putApi,
    getJsonApi
} from "../modules/AmplifyServices";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";
import PropTypes from "prop-types";
import {
    companyIsSoleOperator,
    getUserFromCache,
    userHasMarketboxAdminRole,
    updateCompanyObjectInCachedUser
} from "../user/UserCommon";
import {
    currencies,
    countryCodes,
    subscriptionLevelConst,
    FEATURE_NAME_CLUSTERING,
    SUBDOMAIN_REGEX_SPECIAL_CHARS,
    SUBDOMAIN_REGEX_MULTIPLE_HYPHENS,
    SPECIFIC_TIME,
    ANY_TIME,
    FIRST_AND_LAST_SLOT_OF_BLOCK,
    DEFAULT_BUFFER_TIME_MINS
} from "../utils/Constants";
import * as Sentry from "@sentry/react";
import validator from "validator";
import { auditCompanyUpdate, auditCompanyCreate } from "../modules/Audit";
import StripeConnect from "../components/stripe/StripeConnect";
import validateCompany from "../utils/WhiteLabelling";
import isFeatureGated from "../modules/FeatureGatingModule";
import FeatureGateDialog from "../components/FeatureGateDialog";
import StarsIcon from "@mui/icons-material/Stars";
import {
    TIME_SUGGESTION_CONFIG_DEFAULTS,
    anchorTimeOptions,
    emptyDayAnchorTimeMethodOptions,
    maxTravelTimeMinutesBetweenBookings,
    bufferTimeMinutesBetweenBookings
} from "../utils/Constants";
import { getCountryCode } from "../utils";
import { validateUniqueCompanyName } from "../pages/checkout/modules/ValidityCheck";

import { useAtom } from "jotai";
import {
    brandingStatesAtom,
    domainStatesAtom,
    bookingStatesAtom,
    desiredSubdomainAtom,
    bookingFlowSettingsFilesAtom,
    CompanySettingsTabValueAtom
} from "../atoms/bookingFlowCustomization";
import {
    companyProviderRestrictionConfigAtom,
    mbxUserAtom,
    companyMaxTravelTimeAtom,
    updateCompanyMaxTravelTimeAtom,
    isMbxFreeTrialUserAtom
} from "../atoms/atoms";
import {
    selectedUserIdAtom,
    openUserDialogAtom,
    userModalTabValue,
    openAvailabilityDialogAtom
} from "../atoms/usersTable";
import {
    defaultBookingStates,
    defaultBrandingStates,
    defaultDomainStates,
    defaultBookingFlowSettingsFiles
} from "../utils/Constants";
import BookingFlowSettings from "./BookingFlowSettings/BookingFlowSettings";
import { useNavigate } from "react-router-dom";
import InfoTooltip from "../utils/UI/InfoTooltip";
import { getTimezoneIdByGeoLoc } from "../modules/TimeService";

const axios = require("axios");

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

const autocompleteService = { current: null };
const defaultTagline = "Your company's tagline goes here";
const defaultHeading1Text = "Your Heading 1 Text Goes Here";
const defaultHeading2Text = "Your Heading 2 Text Goes Here";
const defaultTextColor = "#FFFFFF";
const defaultButtonColor = "#0087EE";
const defaultButtonTextColor = "#FFFFFF";
const defaultlogoimg =
    "https://marketbox-prod-booknow.s3.amazonaws.com/public/company-assets/default_logo.png";
const defaultbackgroundimg =
    "https://marketbox-prod-booknow.s3.amazonaws.com/public/company-assets/default_background.png";

export default function CompanyAddEditForm(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const [mbxUser, setMbxUser] = useAtom(mbxUserAtom);
    const [isMbxUserFreeTrial] = useAtom(isMbxFreeTrialUserAtom);
    const { state, actions } = React.useContext(StoreContext);
    // snackbar
    const [msgOpen, setMsgOpen] = useState(false);
    const [snackMsg, setSnackMsg] = useState();
    // fields
    const [name, setName] = useState("");
    const [country, setCountry] = useState("");
    const [contactname, setContactName] = useState("");
    const [emailaddress, setEmailAddress] = useState("");
    const [replyemailaddress, setReplyEmailAddress] = useState("");
    const [currency, setCurrency] = useState("USD");
    const [companyId, setCompanyId] = useState(state.id ? state.id : "");
    const [addressOneLine, setAddressOneLine] = useState("");
    const [addressStreet, setAddressStreet] = useState("");
    const [addressCity, setAddressCity] = useState("");
    const [addressState, setAddressState] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [isEdit, setisEdit] = useState(false);
    const [longitude, setLongitude] = useState(0);
    const [latitude, setLatitude] = useState(0);
    const [oldInfo, setOldInfo] = useState([{}]);
    //loading scree
    const [isLoading, setIsLoading] = useState(true);

    // This state holds the url loaded from getCompanyData
    const [logoUrl, setLogoUrl] = useState(defaultlogoimg);
    // The following two states are required to update the pages with the current uploaded logo file
    const [currentLogoFile, setCurrentLogoFile] = useState("");
    const [iframeUrl, setIframeUrl] = useState("");
    const [stripeKey, setStripeKey] = useState("");
    const [active, setActive] = useState(true);
    const [collectPayments, setCollectPayment] = useState(false);
    const [subdomain, setSubdomain] = useState("");
    const [maskedDomain, setMaskedDomain] = useState("");
    const [serviceFeeType, setServiceFeeType] = useState("PERCENTAGE");
    const [serviceFeeAmount, setServiceFeeAmount] = useState(10);
    const [addServiceFee, setAddserviceFee] = useState(true);
    const [countrycode3166alpha2, setCountrycode3166alpha2] = useState("");
    const [selectProvTimeout, setSelectProvTimeout] = useState(1440);
    const [addProvTimeout, setAddProvTimeout] = useState(1440);
    const [providerMustAcceptAppt, setProviderMustAcceptAppt] = useState(false);
    const [sendratingTipMsg, setSendratingTipMsg] = useState(true);
    const [showTipOption, setShowTipOption] = useState(true);
    const [ratingTipTextMsg, setRatingTipTextMsg] = useState(
        `Please take a moment to leave a rating for [provider-first-name] for your "[service]" session on [booking_short_date]. You may also leave a tip if you wish:\n\n[link]`
    );
    const [offersPackagesOnly, setOffersPackagesOnly] = useState(false);
    const [forceRepeatingPackages, setForceRepeatingPackages] = useState(false);
    const [offersForeverAppt, setOffersForeverAppt] = useState(false);
    const [tagline, setTagline] = useState(defaultTagline);
    const [travelTime, setTravelTime] = useState(30);
    const [currencyBasedOnLocation, setCurrencyBasedOnLocation] =
        useState(false);
    const [bookingReqCreatedList, setBookingReqCreatedList] = useState("");
    const [orderSummaryBccList, setOrderSummaryBccList] = useState("");
    const [subscriptionLevel, setSubscriptionLevel] = useState("PROFESSIONAL");
    const [cancelHours, setCancelHours] = useState(0);
    const [cancelPolicyMinsBefore, setCancelPolicyMinsBefore] = useState(1440);
    const [providerCanCancelAppt, setProviderCanCancelAppt] = useState(true);
    const [canProviderReschedule, setCanProviderReschedule] = useState(true);
    const [canClientReschedule, setCanClientReschedule] = useState(true);
    const [refundOnBookingCancellation, setRefundOnBookingCancellation] =
        useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [showFeatureGateDialog, setShowFeatureGateDialog] = useState(false);
    // tabs
    const [tabValue, setTabValue] = useAtom(CompanySettingsTabValueAtom);
    const [secvalue, setSecvalue] = useState();
    const [newSecvalue, setNewSecvalue] = useState();
    const [showSecvalUploadDialog, setShowSecvalUploadDialog] = useState(false);
    const [welcomeMessageState, setWelcomeMessageState] = useState();
    const [stripeConnectedAccount, setStripeConnectedAccount] = useState(null);
    const [stripeConnectEnabled, setStripeConnectEnabled] = useState(false);
    const [showStripeConnectModal, setShowStripeConnectModal] = useState(false);
    const [showStripeConnectResult, setShowStripeConnectResult] =
        useState(false);
    const [stripeConnectError, setStripeConnectError] = useState(false);

    const [providerAgnosticFlow, setProviderAgnosticFlow] = useState(true);
    const [chipsOrder, setChipsOrder] = useState([]);
    const [chipsOrderCreated, setChipsOrderCreated] = useState([]);
    // Waitlist match settings (stored in RefData table)
    const [waitlistMatchEnabled, setWaitlistMatchEnabled] = useState(true);
    const [waitlistLookBackMonths, setWaitlistLookBackMonths] = useState(6);
    const [chipsWaitlistNotify, setChipsWaitlistNotify] = useState([]);
    const [waitlistNotifyInput, setWaitlistNotifyInput] = useState("");
    const [waitlistMatchConfigExists, setWaitlistMatchConfigExists] =
        useState(false);
    // Schedule change notify settings (stored in RefData table)
    const [scheduleChangeNotifyEnabled, setScheduleChangeNotifyEnabled] =
        useState(false);
    const [chipsScheduleChangeNotify, setChipsScheduleChangeNotify] = useState(
        []
    );
    const [scheduleChangeNotifyInput, setScheduleChangeNotifyInput] =
        useState("");
    const [
        scheduleChangeNotifyConfigExists,
        setScheduleChangeNotifyConfigExists
    ] = useState(false);
    const classes = useStyles();
    const classesnew = useCompanyStyles();
    const classes3 = usePromotionsStyles();
    //type
    const [values, setValues] = useState({
        type: "",
        remote: true,
        premise: true,
        heading1Text: defaultHeading1Text,
        heading2Text: defaultHeading2Text,
        textColor: defaultTextColor,
        buttonColor: defaultButtonColor,
        buttonTextColor: defaultButtonTextColor,
        id: ""
    });
    //Fetching user info from cache.
    const loggedInUser = getUserFromCache();
    const [singleApptOnly, setSingleApptOnly] = useState(false);
    const [brandingStates, setBrandingStates] = useAtom(brandingStatesAtom);
    const [domainStates, setDomainStates] = useAtom(domainStatesAtom);
    const [bookingStates, setBookingStates] = useAtom(bookingStatesAtom);
    const [desiredSubdomain, setDesiredSubdomain] =
        useAtom(desiredSubdomainAtom);
    const [bookingFlowSettingsFiles, setBookingFlowSettingsFiles] = useAtom(
        bookingFlowSettingsFilesAtom
    );

    const [, setSelectedUserId] = useAtom(selectedUserIdAtom);
    const [, setOpenUserDialog] = useAtom(openUserDialogAtom);
    const [, setUserModalTabValue] = useAtom(userModalTabValue);
    const [, setOpenAvailabilityDialog] = useAtom(openAvailabilityDialogAtom);

    const [timeSuggestionsEnabled, setTimeSuggestionsEnabled] = useState(true);
    const [
        timeSuggestionsForceClientAccept,
        setTimeSuggestionsForceClientAccept
    ] = useState(false);
    const [emptyDaySlotsMethod, setEmptyDaySlotsMedhod] = useState(
        TIME_SUGGESTION_CONFIG_DEFAULTS.timeOfFirstBookingOfTheDay
    );
    const [emptyDayFirstBookingTime, setEmptyDayFirstBookingTime] = useState();
    const [providerRestrictionConfig] = useAtom(
        companyProviderRestrictionConfigAtom
    );
    const [companyBufferTime, setCompanyBufferTime] = useState(
        DEFAULT_BUFFER_TIME_MINS
    );
    const [companyMaxTravelTime] = useAtom(companyMaxTravelTimeAtom);
    const [, setCompanyMaxTravelTime] = useAtom(updateCompanyMaxTravelTimeAtom);

    const [canProviderSeeClientName, setCanProviderSeeClientName] = useState(
        providerRestrictionConfig.canProviderSeeClientName
    );
    const [canProviderSeeClientEmail, setCanProviderSeeClientEmail] = useState(
        providerRestrictionConfig.canProviderSeeClientEmail
    );
    const [canProviderSeeClientPhone, setCanProviderSeeClientPhone] = useState(
        providerRestrictionConfig.canProviderSeeClientPhone
    );
    const [canProviderSetMaxTravelTime, setCanProviderSetMaxTravelTime] =
        useState(providerRestrictionConfig.canProviderSetMaxTravelTime);

    const userIsMarketBoxAdmin = userHasMarketboxAdminRole();
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            if (stripeConnectedAccount && !stripeConnectEnabled) {
                async function getStripeAccountDetails(accountId) {
                    const result = await getJsonApi(
                        "stripeconnect",
                        "/account",
                        {
                            queryParams: {
                                stripeAccountId: accountId
                            }
                        }
                    );
                    if (result && result.account) {
                        if (
                            result.account.charges_enabled &&
                            result.account.details_submitted
                        ) {
                            setStripeConnectEnabled(true);
                            setCollectPayment(true);
                            await saveStripeAccountInfo(
                                result.account,
                                state.id,
                                true
                            );
                            setShowStripeConnectResult(true);
                        }
                    } else {
                        setStripeConnectError(true);
                        setShowStripeConnectResult(true);
                    }
                }
                getStripeAccountDetails(stripeConnectedAccount);
            }
        }
        return () => {
            mounted = false;
        };
    }, [stripeConnectedAccount]);

    function showStripeConnectButton() {
        if (stripeKey && secvalue) return false;
        if (stripeConnectEnabled) return false;
        if (stripeConnectedAccount && !stripeConnectEnabled) return true;
        return true;
    }

    async function saveStripeAccountInfo(
        stripeAccountInfo,
        companyId,
        stripeConnectEnabled
    ) {
        try {
            let result = await graphql(
                graphqlOperation(mutations.updateCompany, {
                    input: {
                        id: companyId,
                        stripeConnectEnabled,
                        collectpayment: true,
                        PaymentSettings: JSON.stringify({
                            stripeAccount: stripeAccountInfo
                        })
                    }
                })
            );
            await updateCompanyObjectInCachedUser(result?.data?.updateCompany);
        } catch (e) {
            console.log("error", e);
        }
    }

    function showSuggestionSettings() {
        return !isFeatureGated(subscriptionLevel, FEATURE_NAME_CLUSTERING);
    }

    //setup a default code state
    const [defaultCountryCode, setDefaultCountryCode] = useState({});
    //setup a useEffect hook to configure that default value based on the code value
    useEffect(() => {
        let mounted = true;
        if (mounted)
            countryCodes.filter((item) =>
                item.value === countrycode3166alpha2
                    ? setDefaultCountryCode(item)
                    : console.log("Code not existed")
            );
        return () => {
            mounted = false;
        };
    }, [countrycode3166alpha2]);

    //setup a default enterprise state
    const [defaultSubscriptionLevel, setDefaultSubscriptionLevel] = useState(
        {}
    );

    useEffect(() => {
        let mounted = true;
        if (mounted)
            if (singleApptOnly) {
                setOffersForeverAppt(false);
                setOffersPackagesOnly(false);
                setForceRepeatingPackages(false);
            }
        return () => {
            mounted = false;
        };
    }, [singleApptOnly]);

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            async function fetch() {
                //setLabelWidth(inputLabel.current.offsetWidth);
                setBrandingStates(defaultBrandingStates);
                setDomainStates(defaultDomainStates);
                setBookingStates(defaultBookingStates);
                setBookingFlowSettingsFiles(defaultBookingFlowSettingsFiles);
                setDesiredSubdomain("");

                if (state.mode === "Edit" || state.mode === "View") {
                    await getCompanyData();
                } else {
                    setIsLoading(false);
                }
            }
            fetch();
        }

        return () => {
            mounted = false;
        };
    }, []);

    // service type select
    const [bookingIntervalMinutes, setBookingIntervalMinutes] = useState(1440);
    const [multipleServices, setMultipleServices] = useState(false);
    const [multipleQty, setMultipleQty] = useState(false);

    function throwEditSaveError(errorText, pageNum) {
        //Numerated beginning at 1 in input, but counting starts at 0. Incredibly tragic. Massive blunder.
        let num = pageNum - 1;

        setSnackMsg("Error: " + errorText);
        setMsgOpen(true);
        setTabValue(num);
    }

    async function getCompanyData() {
        setIsLoading(true);
        const companyId = state.id;
        if (!!companyId) {
            setCompanyId(companyId);
            setisEdit(true);
            const input = { id: companyId };
            const result = await graphql(
                graphqlOperation(queries.getCompany, input)
            );

            const {
                data: {
                    publicsiteByCompany: {
                        items: [publicSiteData = {}] = []
                    } = {}
                } = {}
            } = await graphql(
                graphqlOperation(queries.publicsiteByCompany, {
                    companyId: companyId
                })
            );

            let publicResultData = {
                ...publicSiteData
            };

            let originalHeading1Text, originalHeading2Text;

            originalHeading1Text = publicSiteData.heading1Text;
            originalHeading2Text = publicSiteData.heading2Text;

            if (publicSiteData && Object.keys(publicResultData.length > 0)) {
                setValues((oldvalues) => ({
                    ...oldvalues,
                    id: publicSiteData.id
                }));

                if (!publicResultData.StyleCustomization) {
                    setBrandingStates((prevState) => {
                        return {
                            ...prevState,
                            backgroundURL: publicResultData.backgroundImageUrl,
                            buttonColor: publicSiteData.buttonColor,
                            companyTagline:
                                publicSiteData.heading1Text.length > 0
                                    ? publicSiteData.heading1Text
                                    : "Describe your what company offers",
                            companyDescription:
                                publicSiteData.heading2Text.length > 0
                                    ? publicSiteData.heading2Text
                                    : "Put a call to action or your company slogan",
                            headerFontColor: publicSiteData.textColor,
                            logoURL: publicSiteData.company.logoUrl,
                            companyName:
                                publicSiteData.company.name > 0
                                    ? publicSiteData.company.name
                                    : "Put your company name here",
                            showHeader: true,
                            backgroundColor: publicSiteData.buttonColor,
                            headerTransparency: 1,
                            showHeadingOne: true,
                            showHeadingTwo: true,
                            showHeadingThree: true
                        };
                    });
                }

                //StyleCustomization.bookingFlowCustomizations
                if (
                    publicResultData.StyleCustomization &&
                    publicResultData.StyleCustomization.length > 0
                ) {
                    let publicResultDataStyle = JSON.parse(
                        publicResultData.StyleCustomization
                    );

                    if (
                        publicResultDataStyle?.bookingFlowCustomizations
                            ?.mandatoryNotes
                    ) {
                        setBookingStates((prevState) => {
                            return {
                                ...prevState,
                                mandatoryNotes:
                                    publicResultDataStyle
                                        .bookingFlowCustomizations
                                        .mandatoryNotes
                            };
                        });
                    }
                    if (
                        publicResultDataStyle?.bookingFlowCustomizations
                            ?.zeroBookingsPackage
                    ) {
                        setBookingStates((prevState) => {
                            return {
                                ...prevState,
                                zeroBookingsPackage:
                                    publicResultDataStyle
                                        .bookingFlowCustomizations
                                        .zeroBookingsPackage
                            };
                        });
                    }
                    if (
                        publicResultDataStyle?.bookingFlowCustomizations
                            ?.hidePhysicalLocationAddress
                    ) {
                        setBookingStates((prevState) => {
                            return {
                                ...prevState,
                                hidePhysicalLocationAddress:
                                    publicResultDataStyle
                                        .bookingFlowCustomizations
                                        .hidePhysicalLocationAddress
                            };
                        });
                    }
                    if (
                        publicResultDataStyle?.tipPageCustomizations
                            ?.showTipOption !== undefined
                    ) {
                        setShowTipOption(
                            publicResultDataStyle.tipPageCustomizations
                                .showTipOption
                        );
                    }

                    publicResultData.StyleCustomization = {
                        ...publicResultDataStyle
                    };

                    let bookingFlowCustomValues = {
                        ...publicResultData?.StyleCustomization
                            ?.bookingFlowCustomizations
                    };

                    setBookingStates((prevState) => {
                        return {
                            ...prevState,
                            categoryDisplay:
                                bookingFlowCustomValues.categoryDisplay
                                    ? bookingFlowCustomValues.categoryDisplay
                                    : "ALLOPEN",
                            servicesDisplay:
                                bookingFlowCustomValues.servicesDisplay
                                    ? bookingFlowCustomValues.servicesDisplay
                                    : "CARD",
                            checkoutOption:
                                bookingFlowCustomValues.checkoutOption
                                    ? bookingFlowCustomValues.checkoutOption
                                    : "ACCOUNT_OR_GUEST",
                            displayServicePrices:
                                bookingFlowCustomValues &&
                                bookingFlowCustomValues.displayServicePrices !==
                                    undefined
                                    ? bookingFlowCustomValues.displayServicePrices
                                    : true,
                            defaultLanguage:
                                bookingFlowCustomValues &&
                                bookingFlowCustomValues.defaultLanguage
                                    ? bookingFlowCustomValues.defaultLanguage
                                    : "en"
                        };
                    });
                    setBrandingStates((prevState) => {
                        return {
                            backgroundURL: publicResultData.backgroundImageUrl,
                            buttonColor: publicResultData.buttonColor,
                            buttonTextColor:
                                publicResultDataStyle.bookingFlowCustomizations
                                    .buttonTextColor,
                            companyTagline: publicResultData.heading1Text,
                            companyDescription: publicResultData.heading2Text,
                            headerFontColor: publicResultData.textColor,
                            logoURL: publicResultData.company.logoUrl,
                            showLogo: bookingFlowCustomValues.showLogo,
                            logoAsCircle: bookingFlowCustomValues.circularLogo,
                            showHeader: bookingFlowCustomValues.showHeader,
                            backgroundColor:
                                bookingFlowCustomValues.backgroundColor,
                            backgroundImageFit:
                                bookingFlowCustomValues.backgroundImageFit ||
                                "cover",
                            headerTransparency: bookingFlowCustomValues.opacity,
                            showHeaderText:
                                bookingFlowCustomValues.showHeadings,
                            companyName: bookingFlowCustomValues.mainHeading,
                            headerFontType:
                                bookingFlowCustomValues.fontTypeForAllHeading,
                            companyNameFontSize:
                                bookingFlowCustomValues.fontSizeHeader1,
                            companyTaglineFontSize:
                                bookingFlowCustomValues.fontSizeHeader2,
                            companyDescriptionFontSize:
                                bookingFlowCustomValues.fontSizeHeader3,
                            showHeadingOne:
                                bookingFlowCustomValues.hasOwnProperty(
                                    "showHeadingOne"
                                )
                                    ? bookingFlowCustomValues.showHeadingOne
                                    : true,
                            showHeadingTwo:
                                bookingFlowCustomValues.hasOwnProperty(
                                    "showHeadingTwo"
                                )
                                    ? bookingFlowCustomValues.showHeadingTwo
                                    : true,
                            showHeadingThree:
                                bookingFlowCustomValues.hasOwnProperty(
                                    "showHeadingThree"
                                )
                                    ? bookingFlowCustomValues.showHeadingThree
                                    : true
                        };
                    });
                }
            }
            let tosURL;
            const tosExists = await getJsonApi(
                "s3filemgmt",
                `/exists/${result.data.getCompany.id}/${"tos"}`
            );
            if (tosExists.success === true) {
                tosURL = `https://marketbox-prod-booknow.s3.amazonaws.com/public/tos/${result.data.getCompany.id}-tos.pdf`;
                setBookingStates((prevState) => {
                    return {
                        ...prevState,
                        tosURL: tosURL
                    };
                });
            }

            if (!(!!result.errors && result.errors.length > 0)) {
                const {
                    name,
                    contactname,
                    emailaddress,
                    replyemailaddress,
                    currency,
                    addressoneline,
                    street,
                    bookingIntervalMinutes,
                    city,
                    state,
                    country,
                    postalcode,
                    longitude,
                    latitude,
                    active,
                    offersOnPremiseServices,
                    offersRemoteServices,
                    currencyBasedOnLocation,
                    collectpayment,
                    subdomain,
                    maskeddomain,
                    tagline,
                    logoUrl,
                    iframeURL,
                    primaryColor,
                    publishableStripeKey,
                    serviceFeeAmount,
                    serviceFeeType,
                    addServiceFee,
                    countrycode3166alpha2,
                    displayOnlyLogo,
                    providerMustAcceptAppt,
                    ratingTipTextMsg,
                    sendratingTipMsg,
                    offersPackagesOnly,
                    forceRepeatingPackages,
                    offersForeverAppt,
                    ApptAcceptanceFlowConfig,
                    travelTime,
                    homepage,
                    multipleServices,
                    multipleQty,
                    useAnonymousPermalink,
                    clientnotesheading,
                    BccLists,
                    hideRatingsFromClients,
                    subscriptionLevel,
                    cancelPolicyMinsBefore,
                    providerCanCancelAppt,
                    noProviderMsg,
                    displayProviderRatios,
                    bookingIncrement,
                    stripeAccount,
                    stripeConnectEnabled,
                    singleApptOnly,
                    setupCompleted,
                    providerCanReschedule,
                    ProviderRestrictionConfig,
                    clientCanReschedule,
                    ProvAgnoFlowConfig,
                    SuggestionConfig,
                    clientMayCreateAccount,
                    refundOnCancellation
                } = result.data.getCompany;
                setBookingStates((prevState) => {
                    return {
                        ...prevState,
                        clientMayCreateAccount: !!clientMayCreateAccount
                    };
                });
                props.assignModalTitleCompanyName(name);

                setSingleApptOnly(singleApptOnly ? singleApptOnly : false);
                setStripeConnectEnabled(
                    stripeConnectEnabled ? stripeConnectEnabled : false
                );
                setStripeConnectedAccount(stripeAccount ? stripeAccount : null);
                if (ProvAgnoFlowConfig) {
                    const provAgnoFlowConfigObj =
                        JSON.parse(ProvAgnoFlowConfig);
                    setProviderAgnosticFlow(provAgnoFlowConfigObj?.isEnabled);
                }
                if (!ProvAgnoFlowConfig) {
                    //if config does not exist, provider directory is ON and agnostic flow is OFF
                    setProviderAgnosticFlow(false);
                }
                if (SuggestionConfig) {
                    const suggestionConfigObj = JSON.parse(SuggestionConfig);
                    const {
                        isEnabled,
                        timeOfFirstBookingOfTheDay,
                        forceClientAccept,
                        maxTravelTimeMinutes
                    } = suggestionConfigObj;
                    setTimeSuggestionsEnabled(isEnabled);
                    setEmptyDaySlotsMedhod(
                        timeOfFirstBookingOfTheDay !== ANY_TIME &&
                            timeOfFirstBookingOfTheDay !==
                                FIRST_AND_LAST_SLOT_OF_BLOCK
                            ? SPECIFIC_TIME
                            : timeOfFirstBookingOfTheDay
                    );
                    if (
                        timeOfFirstBookingOfTheDay !== ANY_TIME &&
                        timeOfFirstBookingOfTheDay !==
                            FIRST_AND_LAST_SLOT_OF_BLOCK
                    )
                        setEmptyDayFirstBookingTime(timeOfFirstBookingOfTheDay);
                    setTimeSuggestionsForceClientAccept(forceClientAccept);
                    setCompanyMaxTravelTime(maxTravelTimeMinutes);
                }
                setTravelTime(
                    travelTime ? travelTime : 0 === travelTime ? 0 : 30
                );
                setName(name);
                setStripeKey(publishableStripeKey);
                if (setServiceFeeAmount) setServiceFeeAmount(serviceFeeAmount);
                if (serviceFeeType) setServiceFeeType(serviceFeeType);
                setAddserviceFee(addServiceFee);
                setContactName(contactname);
                setEmailAddress(emailaddress);
                setReplyEmailAddress(replyemailaddress);
                setBookingIntervalMinutes(bookingIntervalMinutes);
                setAddressOneLine(addressoneline);
                setAddressCity(city);
                setAddressState(state);
                setPostalCode(postalcode);
                setCountry(country);
                setCurrency(currency);
                setActive(active);
                setAddressStreet(street);
                setLongitude(longitude);
                setLatitude(latitude);
                setCollectPayment(collectpayment);
                setSubdomain(subdomain);
                setDesiredSubdomain(subdomain);
                setMaskedDomain(maskeddomain);
                setTagline(tagline ? tagline : name ? name : defaultTagline);
                setLogoUrl(logoUrl ? logoUrl : defaultlogoimg);
                setIframeUrl(iframeURL ? iframeURL : "");
                setCountrycode3166alpha2(
                    countrycode3166alpha2 ? countrycode3166alpha2 : ""
                );
                setProviderMustAcceptAppt(providerMustAcceptAppt);
                setSendratingTipMsg(sendratingTipMsg);
                setOffersPackagesOnly(offersPackagesOnly);
                setForceRepeatingPackages(forceRepeatingPackages);
                setOffersForeverAppt(offersForeverAppt);
                setCurrencyBasedOnLocation(currencyBasedOnLocation);
                if (!!ratingTipTextMsg) setRatingTipTextMsg(ratingTipTextMsg);
                setSwitches({
                    target: { name: "remote", checked: offersRemoteServices }
                });
                setSwitches({
                    target: {
                        name: "premise",
                        checked: offersOnPremiseServices
                    }
                });

                setMultipleServices(multipleServices);
                setMultipleQty(multipleQty);

                let homepageState;
                if (homepage) {
                    if (homepage.length <= 0) {
                        homepageState = "";
                    } else {
                        let split_homepage = homepage.includes("http")
                            ? homepage.split("//")[1]
                            : homepage;
                        homepageState = split_homepage;
                    }
                }
                let subdomainState;
                if (result.data.getCompany.subdomain) {
                    if (subdomain.length <= 0) {
                        subdomainState = subdomain;
                    } else {
                        let split_subdomain = subdomain.includes(".gomarketbox")
                            ? subdomain.split(".gomarketbox")[0]
                            : subdomain;
                        subdomainState = split_subdomain;
                    }
                }

                let taglineState;
                if (tagline?.length <= 0) {
                    taglineState = name;
                } else {
                    taglineState = tagline;
                }

                setDomainStates((prevState) => {
                    if (result)
                        return {
                            ...prevState,
                            homepageURL: homepageState,
                            subdomain: subdomainState,
                            tagline: taglineState
                        };
                });

                setBookingStates((prevState) => {
                    return {
                        ...prevState,
                        clientNotesHeading: clientnotesheading,
                        displayProviderRatings: !hideRatingsFromClients,
                        useAnonymousPermalink: useAnonymousPermalink,
                        bookingIncrements: bookingIncrement,
                        noProviderMessage:
                            noProviderMsg?.length <= 0
                                ? setupCompleted
                                    ? noProviderMsg
                                    : "Thank you for your interest. Unfortunately at this time, there is no availability in your area. Please leave your contact info and we will reach out when this changes."
                                : noProviderMsg,
                        showProviderAcceptance: displayProviderRatios
                    };
                });

                setBrandingStates((prevState) => {
                    return {
                        ...prevState,
                        displayNameNextToLogo: !displayOnlyLogo,
                        primaryColor: primaryColor
                    };
                });

                let ordList = "",
                    welcomeList = "",
                    bookingReqCreatedList = "",
                    bookingReqExpiredList = "";

                if (BccLists) {
                    let obj = JSON.parse(BccLists);
                    if (
                        obj.hasOwnProperty("forOrdSum") &&
                        obj["forOrdSum"].length > 0
                    ) {
                        setChipsOrder([...obj["forOrdSum"]]);
                        ordList = obj["forOrdSum"].join(";");
                    }

                    if (
                        obj.hasOwnProperty("forBookingReqCreated") &&
                        obj["forBookingReqCreated"].length > 0
                    ) {
                        setChipsOrderCreated([...obj["forBookingReqCreated"]]);
                        bookingReqCreatedList =
                            obj["forBookingReqCreated"].join(";");
                    }
                }
                if (ApptAcceptanceFlowConfig) {
                    const flowConfig = JSON.parse(ApptAcceptanceFlowConfig);
                    if (flowConfig.selectProvTimeout) {
                        setSelectProvTimeout(flowConfig.selectProvTimeout);
                    }
                    if (flowConfig.addProvTimeout) {
                        setAddProvTimeout(flowConfig.addProvTimeout);
                    }
                }
                setSubscriptionLevel(
                    subscriptionLevel ? subscriptionLevel : ""
                );
                setCancelPolicyMinsBefore(
                    cancelPolicyMinsBefore ? cancelPolicyMinsBefore : 0
                );
                setProviderCanCancelAppt(
                    providerCanCancelAppt === null
                        ? true
                        : providerCanCancelAppt
                );
                if (providerCanReschedule) {
                    setCanProviderReschedule(providerCanReschedule);
                } else {
                    setCanProviderReschedule(false);
                }

                if (clientCanReschedule) {
                    setCanClientReschedule(clientCanReschedule);
                } else {
                    setCanClientReschedule(false);
                }
                if (refundOnCancellation) {
                    setRefundOnBookingCancellation(refundOnCancellation);
                } else {
                    setRefundOnBookingCancellation(false);
                }

                let curData = {
                    name: name,
                    contactname: contactname,
                    emailaddress: emailaddress,
                    address: addressoneline,
                    currency: currency,
                    country: countrycode3166alpha2,
                    role: subscriptionLevel,
                    stripeKey: publishableStripeKey,
                    tipMsg: sendratingTipMsg,
                    textMsg: ratingTipTextMsg,
                    clientMsg: clientnotesheading,
                    ordList, //: convertArrayToString(BccLists, "forOrdSum"),
                    welcomeList, //: convertArrayToString(BccLists, "forWelcome"),
                    bookingReqCreatedList, //: convertArrayToString(BccLists,"bookingReqCreatedList"),
                    bookingReqExpiredList, //: convertArrayToString(BccLists,"bookingReqExpiredList"),
                    subdomain: subdomain,
                    tagline: tagline,
                    heading1Text: originalHeading1Text
                        ? originalHeading1Text
                        : values.heading1Text,
                    heading2Text: originalHeading2Text
                        ? originalHeading2Text
                        : values.heading2Text,
                    noProviderMsg: noProviderMsg,
                    currencyByLocation: currencyBasedOnLocation,
                    offersMobileServices: offersRemoteServices,
                    offersOnPremiseServices: offersOnPremiseServices,

                    displayOnlyLogo: displayOnlyLogo,
                    singleApptOnly: singleApptOnly,
                    offersPackagesOnly: offersPackagesOnly,
                    forceRepeatingPackages,
                    offersForeverAppt: offersForeverAppt,
                    multipleServices: multipleServices,
                    multipleQuantity: multipleQty,
                    hideProviderRatingsfromClients: hideRatingsFromClients,
                    useAnonymousPermalink: useAnonymousPermalink,
                    providerMustAcceptBooking: providerMustAcceptAppt,
                    providerCanCancelAppt: providerCanCancelAppt,
                    providerMayRescheduleBooking: providerCanReschedule,
                    ProviderRestrictionConfig: JSON.stringify({
                        canProviderSeeClientName: canProviderSeeClientName,
                        canProviderSeeClientEmail: canProviderSeeClientEmail,
                        canProviderSeeClientPhone: canProviderSeeClientPhone,
                        canProviderSetMaxTravelTime: canProviderSetMaxTravelTime
                    }),
                    clientMayRescheduleBooking: clientCanReschedule,
                    primaryColor: primaryColor,
                    serviceFeeAmount: serviceFeeAmount,
                    serviceFeeType: serviceFeeType,
                    addServiceFee: addServiceFee,
                    minTime: bookingIntervalMinutes,
                    travelTime: travelTime,
                    cancelPolicy: cancelPolicyMinsBefore,
                    providerRatios:
                        displayProviderRatios === null
                            ? false
                            : displayProviderRatios,
                    addProvTimeout: parseInt(
                        JSON.parse(ApptAcceptanceFlowConfig)?.addProvTimeout
                    ),
                    selectProvTimeout: parseInt(
                        JSON.parse(ApptAcceptanceFlowConfig)?.selectProvTimeout
                    )
                };
                setOldInfo([curData]);
            }

            //get secvalue
            const stripePubKey = await readStripeSecvalue(companyId);

            // Fetch waitlist match config from RefData
            try {
                const waitlistConfigResult = await graphql(
                    graphqlOperation(queries.getRefData, {
                        refType: `waitlist-match-config|${companyId}`,
                        refName: "waitlist-match-config"
                    })
                );
                const waitlistConfig = waitlistConfigResult?.data?.getRefData;
                if (waitlistConfig?.overrideValue) {
                    const config =
                        typeof waitlistConfig.overrideValue === "string"
                            ? JSON.parse(waitlistConfig.overrideValue)
                            : waitlistConfig.overrideValue;
                    setWaitlistMatchEnabled(
                        config.enabled !== undefined ? config.enabled : true
                    );
                    setWaitlistLookBackMonths(
                        config.lookBackMonths !== undefined
                            ? config.lookBackMonths
                            : 6
                    );
                    if (
                        config.notifyEmails &&
                        Array.isArray(config.notifyEmails) &&
                        config.notifyEmails.length > 0
                    ) {
                        setChipsWaitlistNotify([...config.notifyEmails]);
                    }
                    setWaitlistMatchConfigExists(true);
                }
            } catch (err) {
                console.error("Error fetching waitlist match config:", err);
            }

            // Fetch schedule change notify config from RefData
            try {
                const scheduleChangeConfigResult = await graphql(
                    graphqlOperation(queries.getRefData, {
                        refType: `schedule-change-notify-config|${companyId}`,
                        refName: "schedule-change-notify-config"
                    })
                );
                const scheduleChangeConfig =
                    scheduleChangeConfigResult?.data?.getRefData;
                if (scheduleChangeConfig?.overrideValue) {
                    const config =
                        typeof scheduleChangeConfig.overrideValue === "string"
                            ? JSON.parse(scheduleChangeConfig.overrideValue)
                            : scheduleChangeConfig.overrideValue;
                    setScheduleChangeNotifyEnabled(
                        config.enabled !== undefined ? config.enabled : false
                    );
                    if (
                        config.notifyEmails &&
                        Array.isArray(config.notifyEmails) &&
                        config.notifyEmails.length > 0
                    ) {
                        setChipsScheduleChangeNotify([...config.notifyEmails]);
                    }
                    setScheduleChangeNotifyConfigExists(true);
                }
            } catch (err) {
                console.error(
                    "Error fetching schedule change notify config:",
                    err
                );
            }

            setIsLoading(false);
            return { ...result.data.getCompany, stripePubKey };
        } else {
            setCompanyId("");
            setisEdit(false);
        }
        setIsLoading(false);
        return;
    }

    async function readStripeSecvalue(companyId) {
        try {
            //get secvalue
            const secval = await getJsonApi("adminapi", `/secval`, {
                queryParams: {
                    companyId,
                    valueType: "SS"
                }
            });
            if (secval && secval.value) {
                setSecvalue(secval.value);
                return secval.value;
            }
        } catch (e) {
            console.log("error in api call");
        }
    }

    async function isSubdomainProvisioned(subdomain) {
        //get secvalue
        const yesno = await getJsonApi("adminapi", `/subdomain`, {
            queryParams: {
                subdomain
            }
        });
        return yesno && yesno.value;
    }

    async function uploadFile(file, fileType, companyIdValue) {
        try {
            let fileName = "";
            if (fileType === "logo") {
                const fileExtension = file.name.substring(
                    file.name.lastIndexOf(".") + 1
                );
                fileName = `${companyIdValue.toString()}-${Date.now()}-logo.${fileExtension}`;
            } else if (fileType === "tos") {
                fileName = companyIdValue.toString() + "-tos.pdf";
            } else if (fileType === "backgroundImage") {
                const fileExtension = file.name.substring(
                    file.name.lastIndexOf(".") + 1
                );
                fileName = `${companyIdValue.toString()}-${Date.now()}-backgroundImage.${fileExtension}`;
            } else throw new Error("Unsupported file type.");
            const response = await postApi("s3filemgmt", "/upload", {
                body: {
                    companyId,
                    fileName: fileName,
                    fileType: fileType
                }
            });
            var options = {
                headers: {
                    "Content-Type": file.type
                }
            };
            await axios.put(response.uploadURL, file, options);
            const url = response.uploadURL.split("?");
            if (fileType === "logo") {
                setLogoUrl(url[0]);
            }
            return url[0];
        } catch (err) {
            console.log("File upload error", err);
            Sentry.captureException(err);
            setSnackMsg("Error uploading company logo.");
            setMsgOpen(true);
        }
    }

    function isValidColor(color) {
        const hexColorRegex = /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i;
        return hexColorRegex.test(color);
    }

    const handleInputKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (event.target.id === "bcc-list-1") {
                addChip(orderSummaryBccList.trim(), "orderBcc");
            }
            if (event.target.id === "orderCreated-emails") {
                addChip(bookingReqCreatedList.trim(), "orderCreated");
            }
            if (event.target.id === "ac-waitlist-notify-emails") {
                addChip(waitlistNotifyInput.trim(), "waitlistNotify");
            }
            if (event.target.id === "ac-schedule-change-notify-emails") {
                addChip(
                    scheduleChangeNotifyInput.trim(),
                    "scheduleChangeNotify"
                );
            }
        }
    };

    const addChip = (chipValue, str) => {
        if (str === "orderBcc") {
            if (chipValue && !chipsOrder.includes(chipValue)) {
                setChipsOrder([...chipsOrder, chipValue]);
                setOrderSummaryBccList("");
            }
        }
        if (str === "orderCreated") {
            if (chipValue && !chipsOrderCreated.includes(chipValue)) {
                setChipsOrderCreated([...chipsOrderCreated, chipValue]);
                setBookingReqCreatedList("");
            }
        }
        if (str === "waitlistNotify") {
            if (chipValue && !chipsWaitlistNotify.includes(chipValue)) {
                setChipsWaitlistNotify([...chipsWaitlistNotify, chipValue]);
                setWaitlistNotifyInput("");
            }
        }
        if (str === "scheduleChangeNotify") {
            if (chipValue && !chipsScheduleChangeNotify.includes(chipValue)) {
                setChipsScheduleChangeNotify([
                    ...chipsScheduleChangeNotify,
                    chipValue
                ]);
                setScheduleChangeNotifyInput("");
            }
        }
    };

    const removeChip = (chipValue, str) => {
        if (str === "orderBcc") {
            setChipsOrder(chipsOrder.filter((chip) => chip !== chipValue));
        }

        if (str === "orderCreated") {
            setChipsOrderCreated(
                chipsOrderCreated.filter((chip) => chip !== chipValue)
            );
        }

        if (str === "waitlistNotify") {
            setChipsWaitlistNotify(
                chipsWaitlistNotify.filter((chip) => chip !== chipValue)
            );
        }

        if (str === "scheduleChangeNotify") {
            setChipsScheduleChangeNotify(
                chipsScheduleChangeNotify.filter((chip) => chip !== chipValue)
            );
        }
    };

    async function addCompany() {
        // Steps to add a company:
        // 1. Create the company with all company data that does not require the company id
        // 2. Take the company id, and use that to upload the data requiring a company id
        // 3. Finally, update the company with the urls that require the company id

        // If we are creating a company, we need to first get the company Id in order to be able to upload
        // the TOS, Logo, or background image.
        // If we are editing a company, we first need to upload the file, and then save the link to the company
        // with the link.
        try {
            let input = {
                name: name,
                contactname: contactname,
                emailaddress: emailaddress,
                replyemailaddress: replyemailaddress,
                currency: currency,
                addressoneline: addressOneLine,
                street: addressStreet,
                city: addressCity,
                state: addressState,
                country: country,
                postalcode: postalCode,
                longitude: longitude,
                latitude: latitude,
                active: active,
                offersOnPremiseServices: values.premise,
                offersRemoteServices: values.remote,
                currencyBasedOnLocation: currencyBasedOnLocation,
                collectpayment: collectPayments,
                subdomain: desiredSubdomain
                    ? desiredSubdomain
                    : `${name
                          .toLowerCase()
                          .trim()
                          .replace(SUBDOMAIN_REGEX_SPECIAL_CHARS, "")
                          .replace(
                              SUBDOMAIN_REGEX_MULTIPLE_HYPHENS,
                              "-"
                          )}.gomarketbox.com`,
                maskeddomain: maskedDomain,
                logoUrl: brandingStates.logoURL,
                iframeURL: iframeUrl ? iframeUrl : "",
                tagline: domainStates.tagline.trim()
                    ? domainStates.tagline.trim()
                    : name,
                primaryColor: brandingStates.primaryColor
                    ? brandingStates.primaryColor
                    : "#0087EE",
                publishableStripeKey: stripeKey,
                serviceFeeAmount: parseFloat(serviceFeeAmount),
                serviceFeeType: serviceFeeType,
                addServiceFee: addServiceFee,
                bookingIntervalMinutes: bookingIntervalMinutes,
                countrycode3166alpha2: countrycode3166alpha2,
                displayOnlyLogo: !brandingStates.displayNameNextToLogo,
                providerMustAcceptAppt: providerMustAcceptAppt,
                ratingTipTextMsg: ratingTipTextMsg,
                sendratingTipMsg: sendratingTipMsg,
                offersPackagesOnly: offersPackagesOnly,
                forceRepeatingPackages,
                offersForeverAppt: offersForeverAppt,
                ApptAcceptanceFlowConfig: JSON.stringify({
                    selectProvTimeout: selectProvTimeout,
                    addProvTimeout: addProvTimeout
                }),
                travelTime,
                homepage: domainStates.homepageURL
                    ? `https://${domainStates.homepageURL.trim()}`
                    : "",
                multipleServices: multipleServices,
                multipleQty: multipleQty,
                useAnonymousPermalink: bookingStates.useAnonymousPermalink,
                clientnotesheading: bookingStates.clientNotesHeading,
                //BccLists is used for all the emaill address lists and not just for Bcc addresses
                BccLists: JSON.stringify({
                    forOrdSum: chipsOrder, //convertStringToArray(orderSummaryBccList),
                    forBookingReqCreated: chipsOrderCreated //convertStringToArray(bookingReqCreatedList),
                }),
                hideRatingsFromClients: !bookingStates.displayProviderRatings,
                subscriptionLevel: subscriptionLevel ? subscriptionLevel : "",
                cancelPolicyMinsBefore: cancelPolicyMinsBefore
                    ? cancelPolicyMinsBefore
                    : 0,
                providerCanCancelAppt: providerCanCancelAppt,
                noProviderMsg: bookingStates.noProviderMessage,
                displayProviderRatios: bookingStates.showProviderAcceptance,
                bookingIncrement: bookingStates.bookingIncrements,
                singleApptOnly: singleApptOnly,
                providerCanReschedule: canProviderReschedule,
                ProviderRestrictionConfig: JSON.stringify({
                    canProviderSeeClientName: canProviderSeeClientName,
                    canProviderSeeClientEmail: canProviderSeeClientEmail,
                    canProviderSeeClientPhone: canProviderSeeClientPhone,
                    canProviderSetMaxTravelTime: canProviderSetMaxTravelTime
                }),
                clientCanReschedule: canClientReschedule,
                ProvAgnoFlowConfig: JSON.stringify({
                    isEnabled: providerAgnosticFlow
                }),
                SuggestionConfig: JSON.stringify({
                    isEnabled: isFeatureGated(
                        subscriptionLevel,
                        FEATURE_NAME_CLUSTERING
                    )
                        ? false
                        : timeSuggestionsEnabled
                          ? true
                          : false,
                    timeOfFirstBookingOfTheDay:
                        emptyDaySlotsMethod === SPECIFIC_TIME
                            ? emptyDayFirstBookingTime
                            : emptyDaySlotsMethod,
                    forceClientAccept: timeSuggestionsForceClientAccept
                        ? true
                        : false,
                    maxTravelTimeMinutes: companyMaxTravelTime
                }),
                clientMayCreateAccount: bookingStates.clientMayCreateAccount,
                refundOnCancellation: refundOnBookingCancellation
                //setupCompleted: true
            };
            let response;

            let publicInput = {
                heading1Text: brandingStates.companyTagline,
                heading2Text: brandingStates.companyDescription,
                buttonColor: brandingStates.buttonColor,
                textColor: brandingStates.headerFontColor,
                backgroundImageUrl: brandingStates.backgroundURL
            };

            let customValues = {
                bookingFlowCustomizations: {
                    mainHeading: brandingStates.companyName,
                    backgroundColor: brandingStates.backgroundColor,
                    opacity: brandingStates.headerTransparency,
                    fontTypeForAllHeading: brandingStates.headerFontType,
                    fontSizeHeader1: brandingStates.companyNameFontSize,
                    fontSizeHeader2: brandingStates.companyTaglineFontSize,
                    fontSizeHeader3: brandingStates.companyDescriptionFontSize,
                    showHeadings: brandingStates.showHeaderText,
                    showLogo: brandingStates.showLogo,
                    showBackgroundImage: brandingStates.showBackgroundImage,
                    circularLogo: brandingStates.logoAsCircle,
                    initialSetup: true,
                    showHeader: brandingStates.showHeader,
                    backgroundImageFit:
                        brandingStates.backgroundImageFit || "cover",
                    categoryDisplay: bookingStates.categoryDisplay,
                    servicesDisplay: bookingStates.servicesDisplay,
                    checkoutOption: bookingStates.checkoutOption,
                    showHeadingOne: brandingStates.showHeadingOne,
                    showHeadingTwo: brandingStates.showHeadingTwo,
                    showHeadingThree: brandingStates.showHeadingThree,
                    displayServicePrices: bookingStates.displayServicePrices,
                    defaultLanguage: bookingStates.defaultLanguage || "en",
                    buttonTextColor: brandingStates.buttonTextColor,
                    mandatoryNotes: bookingStates.mandatoryNotes,
                    zeroBookingsPackage: bookingStates.zeroBookingsPackage,
                    hidePhysicalLocationAddress:
                        bookingStates.hidePhysicalLocationAddress,
                    tipPageCustomizations: {
                        showTipOption: showTipOption
                    }
                }
            };

            customValues.tipPageCustomizations = {
                showTipOption: showTipOption
            };
            publicInput.StyleCustomization = JSON.stringify(customValues);
            // Perform final save.
            if (isEdit) {
                let companyId = state.id;
                input.id = companyId;
                response = await graphql(
                    graphqlOperation(mutations.updateCompany, { input })
                );
                await updateCompanyObjectInCachedUser(
                    response?.data?.updateCompany
                );

                newInfo = Object.fromEntries(
                    Object.entries(newInfo[0]).filter(
                        ([_, v]) => v !== "No Change"
                    )
                );

                if (Object.keys(newInfo).length !== 0) {
                    await auditCompanyUpdate(
                        loggedInUser,
                        response.data.updateCompany,
                        [newInfo],
                        tabValue
                    );
                }

                publicInput.companyId = companyId;

                if (values.id) {
                    publicInput.id = values.id;
                    await graphql(
                        graphqlOperation(mutations.updateCompanyPublicSite, {
                            input: publicInput
                        })
                    );
                }
            } else {
                response = await graphql(
                    graphqlOperation(mutations.createCompany, {
                        input
                    })
                );

                await auditCompanyCreate(
                    loggedInUser,
                    response.data.createCompany
                );

                const createdCompanyId = response.data.createCompany.id;

                publicInput.companyId = createdCompanyId;
                publicInput.companyPublicSiteCompanyId = createdCompanyId;

                if (bookingFlowSettingsFiles.logoFile) {
                    let uploadLogoURL = await uploadFile(
                        bookingFlowSettingsFiles.logoFile,
                        "logo",
                        createdCompanyId
                    );
                    if (uploadLogoURL) {
                        input.logoUrl = uploadLogoURL;
                        input.id = createdCompanyId;

                        setBrandingStates((prevState) => {
                            return { ...prevState, logoURL: uploadLogoURL };
                        });

                        const updatedResponse = await graphql(
                            graphqlOperation(mutations.updateCompany, { input })
                        );

                        await updateCompanyObjectInCachedUser(
                            updatedResponse?.data?.updateCompany
                        );
                    }
                }

                if (bookingFlowSettingsFiles.backgroundFile) {
                    let uploadBackgroundURL = await uploadFile(
                        bookingFlowSettingsFiles.backgroundFile,
                        "logo",
                        createdCompanyId
                    );
                    if (uploadBackgroundURL) {
                        publicInput.backgroundImageUrl = uploadBackgroundURL;

                        setBrandingStates((prevState) => {
                            return {
                                ...prevState,
                                logoURL: uploadBackgroundURL
                            };
                        });
                    }
                }
                if (
                    isFeatureGated(subscriptionLevel, FEATURE_NAME_CLUSTERING)
                ) {
                    setTimeSuggestionsEnabled(false);
                }

                if (bookingFlowSettingsFiles.tosFile) {
                    const newTOSURL = await uploadFile(
                        bookingFlowSettingsFiles.tosFile,
                        "tos",
                        createdCompanyId
                    );

                    if (newTOSURL) {
                        setBookingStates((prevState) => {
                            return { ...prevState, tosURL: newTOSURL };
                        });
                    }
                }

                await graphql(
                    graphqlOperation(mutations.createCompanyPublicSite, {
                        input: publicInput
                    })
                );

                //create a company masterTZ record in refdata
                try {
                    const timezone = await getTimezoneIdByGeoLoc({
                        lat: latitude,
                        lng: longitude
                    });
                    await graphql(
                        graphqlOperation(mutations.createRefData, {
                            input: {
                                refType: `TIMEZONE|${createdCompanyId}`,
                                refName: "timezone",
                                refValue: timezone
                            }
                        })
                    );
                } catch (err) {
                    console.log(
                        "saving company masterTZ to refdata failed",
                        err
                    );
                    Sentry.captureException(err);
                }
            }

            try {
                await reSaveCompanyInfoForLandingPage({
                    ...input,
                    stripeAccount: stripeConnectedAccount,
                    stripeConnectEnabled
                });
            } catch (err) {
                console.log("saving company info to refdata failed", err);
                Sentry.captureException(err);
            }

            try {
                await reSaveCompanyPublicSiteInfoForLandingPage(publicInput);
            } catch (err) {
                console.log(
                    "saving public company info to public refdata failed",
                    err
                );
                Sentry.captureException(err);
            }

            // Save waitlist match config to RefData
            try {
                const savedCompanyId = isEdit
                    ? state.id
                    : response.data.createCompany.id;

                // Commit any pending email input that wasn't chipped yet
                const finalNotifyEmails = [...chipsWaitlistNotify];
                if (
                    waitlistNotifyInput.trim() &&
                    !finalNotifyEmails.includes(waitlistNotifyInput.trim())
                ) {
                    finalNotifyEmails.push(waitlistNotifyInput.trim());
                    setChipsWaitlistNotify(finalNotifyEmails);
                    setWaitlistNotifyInput("");
                }

                const waitlistRefInput = {
                    refType: `waitlist-match-config|${savedCompanyId}`,
                    refName: "waitlist-match-config",
                    refValue: "waitlist-match-config",
                    overrideValue: JSON.stringify({
                        enabled: waitlistMatchEnabled,
                        lookBackMonths: waitlistLookBackMonths,
                        notifyEmails: finalNotifyEmails
                    })
                };
                if (waitlistMatchConfigExists) {
                    await graphql(
                        graphqlOperation(mutations.updateRefData, {
                            input: waitlistRefInput
                        })
                    );
                } else {
                    await graphql(
                        graphqlOperation(mutations.createRefData, {
                            input: waitlistRefInput
                        })
                    );
                    setWaitlistMatchConfigExists(true);
                }
            } catch (err) {
                console.error("Error saving waitlist match config:", err);
                Sentry.captureException(err);
            }

            // Save schedule change notify config to RefData
            try {
                const savedCompanyId = isEdit
                    ? state.id
                    : response.data.createCompany.id;

                // Commit any pending email input that wasn't chipped yet
                const finalScheduleChangeEmails = [
                    ...chipsScheduleChangeNotify
                ];
                if (
                    scheduleChangeNotifyInput.trim() &&
                    !finalScheduleChangeEmails.includes(
                        scheduleChangeNotifyInput.trim()
                    )
                ) {
                    finalScheduleChangeEmails.push(
                        scheduleChangeNotifyInput.trim()
                    );
                    setChipsScheduleChangeNotify(finalScheduleChangeEmails);
                    setScheduleChangeNotifyInput("");
                }

                const scheduleChangeRefInput = {
                    refType: `schedule-change-notify-config|${savedCompanyId}`,
                    refName: "schedule-change-notify-config",
                    refValue: "schedule-change-notify-config",
                    overrideValue: JSON.stringify({
                        enabled: scheduleChangeNotifyEnabled,
                        notifyEmails: finalScheduleChangeEmails
                    })
                };
                if (scheduleChangeNotifyConfigExists) {
                    await graphql(
                        graphqlOperation(mutations.updateRefData, {
                            input: scheduleChangeRefInput
                        })
                    );
                } else {
                    await graphql(
                        graphqlOperation(mutations.createRefData, {
                            input: scheduleChangeRefInput
                        })
                    );
                    setScheduleChangeNotifyConfigExists(true);
                }
            } catch (err) {
                console.error(
                    "Error saving schedule change notify config:",
                    err
                );
                Sentry.captureException(err);
            }

            if (
                response && response.data && isEdit
                    ? response.data.updateCompany
                    : response.data.createCompany
            ) {
                if (isEdit) {
                    return response.data.updateCompany;
                } else {
                    return response.data.createCompany;
                }
            } else {
                throwEditSaveError(
                    "Unable to save the company information.",
                    1
                );
                return null;
            }
        } catch (err) {
            console.error("Add Company error => ", err);
            Sentry.captureException(err);
            return null;
        }
    }

    // function updateCompanyObjectInCachedUser(updatedCompanyObj) {
    //     let cachedUser = getUserFromCache();
    //     if (cachedUser.company.id === updatedCompanyObj.id)
    //         cachedUser.company = updatedCompanyObj;
    // }
    async function reSaveCompanyInfoForLandingPage(company) {
        try {
            let companyInfo = {};

            for (let prop in company) {
                if (
                    "DashboardInfo" !== prop &&
                    "createdAt" !== prop &&
                    "updatedAt" !== prop
                )
                    companyInfo[prop] = company[prop];
            }
            const exists = await graphql(
                graphqlOperation(queries.getRefData, {
                    refType: `domain|${company.subdomain}`,
                    refName: "data-company"
                })
            );
            let refVal = exists.data.getRefData
                ? exists.data.getRefData.refValue
                : null;
            if (refVal)
                await graphql(
                    graphqlOperation(mutations.updateRefData, {
                        input: {
                            refType: `domain|${company.subdomain}`,
                            refName: "data-company",
                            refValue: "company",
                            overrideValue: JSON.stringify(companyInfo)
                        }
                    })
                );
            else
                await graphql(
                    graphqlOperation(mutations.createRefData, {
                        input: {
                            refType: `domain|${company.subdomain}`,
                            refName: "data-company",
                            refValue: "company",
                            overrideValue: JSON.stringify(companyInfo)
                        }
                    })
                );
        } catch (e) {
            console.log("saving company info to refdata failed");
        }
    }

    async function reSaveCompanyPublicSiteInfoForLandingPage(publicSite) {
        try {
            const result = await graphql(
                graphqlOperation(queries.getCompany, {
                    id: publicSite.companyId
                })
            );

            const exists = await graphql(
                graphqlOperation(queries.getRefData, {
                    refType: `domain|${result.data.getCompany.subdomain}`,
                    refName: "data-publicSite"
                })
            );
            let refVal = exists.data.getRefData
                ? exists.data.getRefData.refValue
                : null;
            let overrideValue = {
                backgroundImageUrl: publicSite.backgroundImageUrl,
                heading1Text: publicSite.heading1Text,
                heading2Text: publicSite.heading2Text,
                textColor: publicSite.textColor,
                buttonColor: publicSite.buttonColor
            };
            if (
                publicSite.StyleCustomization &&
                publicSite.StyleCustomization !== null
            )
                overrideValue.StyleCustomization =
                    publicSite.StyleCustomization;
            if (refVal) {
                await graphql(
                    graphqlOperation(mutations.updateRefData, {
                        input: {
                            refType: `domain|${result.data.getCompany.subdomain}`,
                            refName: "data-publicSite",
                            refValue: "publicSite",
                            overrideValue: JSON.stringify(overrideValue)
                        }
                    })
                );
            } else {
                await graphql(
                    graphqlOperation(mutations.createRefData, {
                        input: {
                            refType: `domain|${result.data.getCompany.subdomain}`,
                            refName: "data-publicSite",
                            refValue: "publicSite",
                            overrideValue: JSON.stringify(overrideValue)
                        }
                    })
                );
            }
        } catch (e) {
            console.log("saving company public site info to refdata failed", e);
        }
    }

    let newInfo;
    async function handleSaveCompany() {
        setShowLoading(true);

        if (isMbxUserFreeTrial) {
            //add log to localStorage indicating save was clicked (mainly for free trial quick start guide)
            localStorage.setItem("settingsSaved", "true");
        }

        if (tabValue === 0) {
            newInfo = [
                {
                    name: "No Change",
                    contactname: "No Change",
                    emailaddress: "No Change",
                    address: "No Change",
                    currency: "No Change",
                    country: "No Change",
                    role: "No Change",
                    stripeKey: "No Change"
                }
            ];
        } else if (tabValue === 2) {
            newInfo = [
                {
                    tipMsg: "No Change",
                    textMsg: "No Change",
                    clientMsg: "No Change",
                    ordSum: "No Change",
                    WelcomeList: "No Change"
                }
            ];
        } else if (tabValue === 3) {
            newInfo = [
                {
                    subdomain: "No Change",
                    tagline: "No Change",
                    heading1Text: "No Change",
                    heading2Text: "No Change",
                    noProviderMsg: "No Change",
                    providerRatios: "No Change"
                }
            ];
        } else {
            newInfo = [
                {
                    offersMobileServices: "No Change",
                    offersOnPremiseServices: "No Change",
                    currencyByLocation: "No Change",
                    displayOnlyLogo: "No Change",
                    singleApptOnly: "No Change",
                    offersPackagesOnly: "No Change",
                    forceRepeatingPackages: "No Change",
                    offersForeverAppt: "No Change",
                    multipleServices: "No Change",
                    multipleQuantity: "No Change",
                    primaryColor: "No Change",
                    serviceFeeAmount: "No Change",
                    serviceFeeType: "No Change",
                    addServiceFee: "No Change",
                    hideProviderRatingsfromClients: "No Change",
                    useAnonymousPermalink: "No Change",
                    providerMustAcceptBooking: "No Change",
                    providerCanCancelAppt: "No Change",
                    providerMayRescheduleBooking: "No Change",
                    ProviderRestrictionConfigAtom: "No Change",
                    clientMayRescheduleBooking: "No Change",
                    minTime: "No Change",
                    travelTime: "No Change",
                    cancelPolicy: "No Change",
                    addProvTimeout: "No Change",
                    selectProvTimeout: "No Change"
                }
            ];
        }
        // validate
        if (name === "") {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for name.", 1);
            return;
        }
        if (contactname === "") {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for contact name.", 1);
            return;
        }
        if (emailaddress === "") {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for email address.", 1);
            return;
        }

        if (!validator.isEmail(emailaddress)) {
            setShowLoading(false);
            throwEditSaveError("Please specifiy a valid email address.", 1);
            return;
        }
        if (currency === "") {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for currency.", 1);
            return;
        }

        if (domainStates.subdomain.trim().length <= 0) {
            if (state.mode !== "Add") {
                setShowLoading(false);
                throwEditSaveError(
                    "Personalized Booking URL cannot be empty",
                    4
                );
                setDomainStates((prevState) => {
                    return {
                        ...prevState,
                        subdomainError: true,
                        subdomainErrorMessage:
                            "Personalized Booking URL cannot be empty"
                    };
                });

                return;
            }
        }

        if (domainStates.tagline.trim().length <= 0) {
            if (state.mode === "Add") {
                setDomainStates((prevState) => {
                    return {
                        ...prevState,
                        tagline: name
                    };
                });
            } else {
                setShowLoading(false);
                throwEditSaveError("Title Tag cannot be empty", 4);
                setDomainStates((prevState) => {
                    return {
                        ...prevState,
                        taglineError: true,
                        taglineErrorMessage: "Title Tag cannot be empty"
                    };
                });
                return;
            }
        }

        if (domainStates.subdomainError) {
            setShowLoading(false);
            throwEditSaveError(domainStates.subdomainErrorMessage, 4);
            return;
        }

        if (state.mode !== "Add") {
            if (domainStates.taglineError) {
                setShowLoading(false);
                throwEditSaveError(domainStates.taglineErrorMessage, 4);
                return;
            }
        }

        if (!serviceFeeType) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for service fee type.", 2);
            return;
        }
        if (addServiceFee && !serviceFeeAmount) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for service fee amount.",
                2
            );
            return;
        }
        if (!stripeKey && collectPayments && !stripeConnectEnabled) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for the stripe key.", 5);
            return;
        }
        if (!brandingStates.logoURL && !bookingFlowSettingsFiles.logoFile) {
            setShowLoading(false);
            throwEditSaveError("Please upload a company logo.", 4);
            return;
        }
        if (!brandingStates.primaryColor) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for primary color.", 4);
            return;
        }
        if (
            brandingStates.primaryColor &&
            !isValidColor(brandingStates.primaryColor)
        ) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a valid hex color code for primary color (e.g. #84c9de).",
                4
            );
            return;
        }
        if (!selectProvTimeout || selectProvTimeout < 5) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for selected provider timeout than is greater than or equal to 5 minutes.",
                2
            );
            return;
        }
        if (!addProvTimeout || addProvTimeout < 5) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for additional provider timeout than is greater than or equal to 5 minutes.",
                2
            );
            return;
        }

        if (offersForeverAppt && offersPackagesOnly) {
            setShowLoading(false);
            throwEditSaveError(
                `Invalid Combination: Both "Packages Only" and "Ongoing Appointments Only" are switched on.`,
                2
            );
            return;
        }
        if (!subscriptionLevel) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for subscription level.",
                1
            );
            return;
        }
        if ((!cancelHours && cancelHours !== 0) || cancelHours < 0) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a number greater or equal to 0 for Cancel Time (hrs).",
                2
            );
            return;
        }

        if (
            (!cancelPolicyMinsBefore && cancelPolicyMinsBefore !== 0) ||
            cancelPolicyMinsBefore < 0
        ) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a number greater or equal to 0 for Cancel Time (hours).",
                2
            );
            return;
        }
        // limit to 10080 minutes (one week)
        if (
            (!bookingIntervalMinutes && bookingIntervalMinutes !== 0) ||
            bookingIntervalMinutes < 0 ||
            bookingIntervalMinutes > 10080
        ) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a number in the range of 0 - 168 for Minimum Booking Notice (hours).",
                2
            );
            return;
        }

        if (providerCanCancelAppt === null) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for Provider May Cancel Booking.",
                2
            );
            return;
        }
        // Public Site Settings
        if (brandingStates.showHeadingOne && !brandingStates.companyName) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for heading 1 text.", 4);
            return;
        }
        if (brandingStates.showHeadingTwo && !brandingStates.companyTagline) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for heading 2 text.", 4);
            return;
        }
        if (
            brandingStates.showHeadingThree &&
            !brandingStates.companyDescription
        ) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for heading 3 text.", 4);
            return;
        }
        if (
            !brandingStates.backgroundURL &&
            !bookingFlowSettingsFiles.backgroundFile
        ) {
            setShowLoading(false);
            throwEditSaveError("Please upload a background image.", 4);
            return;
        }
        if (!brandingStates.headerFontColor) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for text color.", 4);
            return;
        }
        if (
            brandingStates.headerFontColor &&
            !isValidColor(brandingStates.headerFontColor)
        ) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a valid hex color code for text color (e.g. #ffffff).",
                4
            );
            return;
        }
        if (!brandingStates.buttonColor) {
            setShowLoading(false);
            throwEditSaveError("Please enter a value for button color.", 4);
            return;
        }
        if (
            brandingStates.buttonColor &&
            !isValidColor(brandingStates.buttonColor)
        ) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a valid hex color code for button color (e.g. #84c9de).",
                4
            );
            return;
        }
        if (!bookingStates.noProviderMessage) {
            setShowLoading(false);
            throwEditSaveError(
                "Please enter a value for No Provider Available Message.",
                4
            );
            return;
        }
        const bookingReqCreatedArr = [...chipsOrderCreated]; //convertStringToArray(bookingReqCreatedList);
        if (providerMustAcceptAppt) {
            for (let emailIndex in bookingReqCreatedArr) {
                if (bookingReqCreatedArr[emailIndex].length === 0) {
                    setShowLoading(false);
                    throwEditSaveError(
                        "Please do not end the Email address list for Order Created notifications  with an extra semicolon.",
                        3
                    );
                    return;
                }
            }
            // bookingReqCreatedList && bookingReqCreatedList.length
            if (chipsOrderCreated.length > 0) {
                let emailArr = [...chipsOrderCreated]; //bookingReqCreatedList.split(";");
                let invalidEmail;

                for (let em of emailArr) {
                    if (!validator.isEmail(em)) {
                        invalidEmail = em;
                        break;
                    }
                }

                if (invalidEmail) {
                    setShowLoading(false);
                    setSnackMsg(
                        `Invalid email address in Email address list for Order Created notifications: ${invalidEmail}`
                    );
                    setMsgOpen(true);
                    throwEditSaveError(
                        `Invalid email address in Email address list for Order Created notifications: ${invalidEmail}`,
                        3
                    );
                    return;
                }
                //bookingReqCreatedList != oldInfo[0].ordList
                if (chipsOrderCreated.join(";") != oldInfo[0].ordList) {
                    newInfo.map((item) => {
                        item.bookingReqCreatedList = emailArr;
                    });
                }
            }
        }

        const ordSumArr = [...chipsOrder]; //convertStringToArray(orderSummaryBccList);
        for (let emailIndex in ordSumArr) {
            if (ordSumArr[emailIndex].length === 0) {
                setShowLoading(false);
                throwEditSaveError(
                    "Please do not end the Welcome Email BCC field with an extra semicolon.",
                    3
                );
                return;
            }
        }
        //orderSummaryBccList && orderSummaryBccList.length
        if (chipsOrder.length > 0) {
            let emailArr = [...chipsOrder]; //orderSummaryBccList.split(";");
            let invalidEmail;

            for (let em of emailArr) {
                if (!validator.isEmail(em)) {
                    invalidEmail = em;
                    break;
                }
            }

            if (invalidEmail) {
                setShowLoading(false);
                setSnackMsg(
                    `Invalid email address in Order Summary Email Bcc email list: ${invalidEmail}`
                );
                setMsgOpen(true);
                throwEditSaveError(
                    `Invalid email address in Order Summary Email Bcc email list: ${invalidEmail}`,
                    3
                );
                return;
            }
            //orderSummaryBccList != oldInfo[0].ordList
            if (chipsOrder.join(";") != oldInfo[0].ordList) {
                newInfo.map((item) => {
                    item.ordSum = emailArr;
                });
            }
        }

        //check to see if the company name is already in use, only if were adding a new company or company name is being changed
        if (
            state.mode === "Add" ||
            (oldInfo[0]?.name && oldInfo[0]?.name !== name)
        ) {
            const isUniqueCompanyName = await validateUniqueCompanyName(name);
            if (!isUniqueCompanyName) {
                setShowLoading(false);
                throwEditSaveError(
                    "A company with this name already exists in our system",
                    1
                );
                return;
            }
        }

        if (isEdit) {
            // General settings changed for audit logging
            if (name != oldInfo[0].name) {
                newInfo.map((item) => {
                    item.name = name;
                });
            }
            if (contactname != oldInfo[0].contactname) {
                newInfo.map((item) => {
                    item.contactname = contactname;
                });
            }
            if (emailaddress != oldInfo[0].emailaddress) {
                newInfo.map((item) => {
                    item.emailaddress = emailaddress;
                });
            }
            if (addressOneLine != oldInfo[0].address) {
                newInfo.map((item) => {
                    item.address = addressOneLine;
                });
            }
            if (countrycode3166alpha2 != oldInfo[0].country) {
                newInfo.map((item) => {
                    item.country = countrycode3166alpha2;
                });
            }
            if (currency != oldInfo[0].currency) {
                newInfo.map((item) => {
                    item.currency = currency;
                });
            }
            if (subscriptionLevel != oldInfo[0].role) {
                newInfo.map((item) => {
                    item.role = subscriptionLevel;
                });
            }
            if (stripeKey != oldInfo[0].stripeKey) {
                newInfo.map((item) => {
                    item.stripeKey = stripeKey;
                });
            }
            if (sendratingTipMsg != oldInfo[0].tipMsg) {
                newInfo.map((item) => {
                    item.tipMsg = sendratingTipMsg;
                });
            }
            if (ratingTipTextMsg != oldInfo[0].textMsg) {
                newInfo.map((item) => {
                    item.textMsg = ratingTipTextMsg;
                });
            }
            if (bookingStates.clientNotesHeading != oldInfo[0].clientMsg) {
                newInfo.map((item) => {
                    item.clientMsg = bookingStates.clientNotesHeading;
                });
            }

            let checkingForWL = validateCompany(companyId);
            if (!checkingForWL?.checked) {
                if (
                    `${domainStates.subdomain}.gomarketbox.com` !=
                    oldInfo[0].subdomain
                ) {
                    newInfo.map((item) => {
                        item.subdomain = domainStates.subdomain;
                    });
                }
            }

            if (domainStates.tagline != oldInfo[0].tagline) {
                newInfo.map((item) => {
                    item.tagline = domainStates.tagline;
                });
            }
            if (brandingStates.companyTagline != oldInfo[0].heading1Text) {
                newInfo.map((item) => {
                    item.heading1Text = brandingStates.companyTagline;
                });
            }
            if (brandingStates.companyDescription != oldInfo[0].heading2Text) {
                newInfo.map((item) => {
                    item.heading2Text = brandingStates.companyDescription;
                });
            }
            if (bookingStates.noProviderMessage != oldInfo[0].noProviderMsg) {
                newInfo.map((item) => {
                    item.noProviderMsg = bookingStates.noProviderMessage;
                });
            }
            if (
                bookingStates.showProviderAcceptance !=
                oldInfo[0].providerRatios
            ) {
                newInfo.map((item) => {
                    item.providerRatios = bookingStates.showProviderAcceptance;
                });
            }

            if (brandingStates.primaryColor != oldInfo[0].primaryColor) {
                newInfo.map((item) => {
                    item.primaryColor = brandingStates.primaryColor;
                });
            }

            if (values.remote != oldInfo[0].offersMobileServices) {
                newInfo.map((item) => {
                    item.offersMobileServices = values.remote;
                });
            }

            if (values.premise != oldInfo[0].offersOnPremiseServices) {
                newInfo.map((item) => {
                    item.offersOnPremiseServices = values.premise;
                });
            }

            if (currencyBasedOnLocation != oldInfo[0].currencyByLocation) {
                newInfo.map((item) => {
                    item.currencyByLocation = currencyBasedOnLocation;
                });
            }

            if (
                !brandingStates.displayNameNextToLogo !=
                oldInfo[0].displayOnlyLogo
            ) {
                newInfo.map((item) => {
                    item.displayOnlyLogo = brandingStates.displayNameNextToLogo;
                });
            }

            if (singleApptOnly != oldInfo[0].singleApptOnly) {
                newInfo.map((item) => {
                    item.singleApptOnly = singleApptOnly;
                });
            }

            if (offersPackagesOnly != oldInfo[0].offersPackagesOnly) {
                newInfo.map((item) => {
                    item.offersPackagesOnly = offersPackagesOnly;
                });
            }
            if (forceRepeatingPackages != oldInfo[0].forceRepeatingPackages) {
                newInfo.map((item) => {
                    item.forceRepeatingPackages = forceRepeatingPackages;
                });
            }
            if (offersForeverAppt != oldInfo[0].offersForeverAppt) {
                newInfo.map((item) => {
                    item.offersForeverAppt = offersForeverAppt;
                });
            }

            if (multipleServices != oldInfo[0].multipleServices) {
                newInfo.map((item) => {
                    item.multipleServices = multipleServices;
                });
            }

            if (multipleQty != oldInfo[0].multipleQuantity) {
                newInfo.map((item) => {
                    item.multipleQuantity = multipleQty;
                });
            }

            if (addServiceFee != oldInfo[0].addServiceFee) {
                newInfo.map((item) => {
                    item.addServiceFee = addServiceFee;
                });
            }

            if (serviceFeeType != oldInfo[0].serviceFeeType) {
                newInfo.map((item) => {
                    item.serviceFeeType = serviceFeeType;
                });
            }

            if (serviceFeeAmount != oldInfo[0].serviceFeeAmount) {
                newInfo.map((item) => {
                    item.serviceFeeAmount = serviceFeeAmount;
                });
            }

            if (
                !bookingStates.displayProviderRatings !=
                oldInfo[0].hideProviderRatingsfromClients
            ) {
                newInfo.map((item) => {
                    item.hideProviderRatingsfromClients =
                        !bookingStates.displayProviderRatings;
                });
            }

            if (
                bookingStates.useAnonymousPermalink !=
                oldInfo[0].useAnonymousPermalink
            ) {
                newInfo.map((item) => {
                    item.useAnonymousPermalink =
                        bookingStates.useAnonymousPermalink;
                });
            }

            if (
                providerMustAcceptAppt != oldInfo[0].providerMustAcceptBooking
            ) {
                newInfo.map((item) => {
                    item.providerMustAcceptBooking = providerMustAcceptAppt;
                });
            }

            if (selectProvTimeout != oldInfo[0].selectProvTimeout) {
                newInfo.map((item) => {
                    item.selectProvTimeout = selectProvTimeout;
                });
            }

            if (addProvTimeout != oldInfo[0].addProvTimeout) {
                newInfo.map((item) => {
                    item.addProvTimeout = addProvTimeout;
                });
            }

            if (providerCanCancelAppt != oldInfo[0].providerCanCancelAppt) {
                newInfo.map((item) => {
                    item.providerCanCancelAppt = providerCanCancelAppt;
                });
            }

            if (
                canProviderReschedule !==
                oldInfo[0]?.providerMayRescheduleBooking
            ) {
                newInfo.map((item) => {
                    item.providerMayRescheduleBooking = canProviderReschedule;
                });
            }

            if (
                canProviderSeeClientName !==
                oldInfo[0]?.canProviderSeeClientName
            ) {
                newInfo.map((item) => {
                    item.canProviderSeeClientName = canProviderSeeClientName;
                });
            }

            if (
                canProviderSeeClientEmail !==
                oldInfo[0]?.canProviderSeeClientEmail
            ) {
                newInfo.map((item) => {
                    item.canProviderSeeClientEmail = canProviderSeeClientEmail;
                });
            }

            if (
                canProviderSeeClientPhone !==
                oldInfo[0]?.canProviderSeeClientPhone
            ) {
                newInfo.map((item) => {
                    item.canProviderSeeClientPhone = canProviderSeeClientPhone;
                });
            }

            if (
                canProviderSetMaxTravelTime !==
                oldInfo[0]?.canProviderSetMaxTravelTime
            ) {
                newInfo.map((item) => {
                    item.canProviderSetMaxTravelTime =
                        canProviderSetMaxTravelTime;
                });
            }

            if (
                canClientReschedule !== oldInfo[0]?.clientMayRescheduleBooking
            ) {
                newInfo.map((item) => {
                    item.clientMayRescheduleBooking = canClientReschedule;
                });
            }

            if (bookingIntervalMinutes != oldInfo[0].minTime) {
                newInfo.map((item) => {
                    item.minTime = bookingIntervalMinutes;
                });
            }
            if (travelTime != oldInfo[0].travelTime) {
                newInfo.map((item) => {
                    item.travelTime = travelTime;
                });
            }
            if (cancelPolicyMinsBefore != oldInfo[0].cancelPolicy) {
                newInfo.map((item) => {
                    item.cancelPolicy = cancelPolicyMinsBefore;
                });
            }
        }

        let subdomainUpdatesData = {
            registerSubdomain: false,
            newSubdomain: null,
            oldSubdomain: null,
            subdomainChanged: false
        };
        try {
            let inputtedSubdomainLC = desiredSubdomain?.toLowerCase();

            if (!inputtedSubdomainLC) {
                // if subdomain field is empty when creating new company, convert company name to url as default subdomain
                let defaultSubdomain = name
                    .toLowerCase()
                    .trim()
                    .replace(SUBDOMAIN_REGEX_SPECIAL_CHARS, "")
                    .replace(SUBDOMAIN_REGEX_MULTIPLE_HYPHENS, "-");

                setDomainStates((prevState) => {
                    return {
                        ...prevState,
                        subdomain: defaultSubdomain
                    };
                });

                inputtedSubdomainLC = `${defaultSubdomain}.gomarketbox.com`;
            }

            let existingSubdomainLC = oldInfo[0].subdomain
                ? oldInfo[0].subdomain.toLowerCase()
                : "";

            //Check if subdomain is provisioned
            let isProvisioned = await isSubdomainProvisioned(
                getSubdomainPrefix(inputtedSubdomainLC)
            );

            if (!isProvisioned) {
                //Check if any other company uses the same domain using the index
                //If not used by any company, set local variable to registerSubdomain = true so that
                //after the company is saved, we can add subdomain to the associated domain in amplify
                const r = await graphql(
                    graphqlOperation(queries.companyBySubdomain, {
                        subdomain: inputtedSubdomainLC
                    })
                );

                if (r.data.companyBySubdomain.items.length === 1) {
                    let company = r.data.companyBySubdomain.items[0];
                    if (companyId !== company.id) {
                        setShowLoading(false);
                        throwEditSaveError("Subdomain is already in use.", 4);
                        return;
                    } else {
                        //companyId is the same but it is not provisioned so, now provision it
                        subdomainUpdatesData.registerSubdomain = true;
                        subdomainUpdatesData.newSubdomain =
                            getSubdomainPrefix(inputtedSubdomainLC);
                        subdomainUpdatesData.subdomainChanged = false;
                    }
                }
                if (r.data.companyBySubdomain.items.length === 0) {
                    subdomainUpdatesData.registerSubdomain = true;
                    subdomainUpdatesData.newSubdomain =
                        getSubdomainPrefix(inputtedSubdomainLC);
                    if (existingSubdomainLC) {
                        subdomainUpdatesData.subdomainChanged = true;
                        subdomainUpdatesData.oldSubdomain =
                            getSubdomainPrefix(existingSubdomainLC);
                    }
                }
            } else {
                if (state.mode === "Add") {
                    setShowLoading(false);
                    throwEditSaveError("Subdomain is already in use.", 4);
                    return;
                } else {
                    const r = await graphql(
                        graphqlOperation(queries.companyBySubdomain, {
                            subdomain: inputtedSubdomainLC
                        })
                    );

                    if (r.data.companyBySubdomain.items.length === 1) {
                        let company = r.data.companyBySubdomain.items[0];
                        if (companyId !== company.id) {
                            setShowLoading(false);
                            throwEditSaveError(
                                "Subdomain is already in use.",
                                4
                            );
                            return;
                        }
                    }
                }
            }
        } catch (e) {
            setShowLoading(false);
            console.log("Error while validating subDomain");
            console.log(e);
        }

        if (
            !!name &&
            /* !!country &&
            !!addressState && */
            !!currency &&
            !!contactname &&
            !!emailaddress &&
            /* !!addressStreet && */
            (!!logoUrl || !!currentLogoFile) &&
            !!serviceFeeType &&
            !!tagline &&
            !!brandingStates.primaryColor &&
            isValidColor(brandingStates.primaryColor)
        ) {
            //This function also handles saving changes for company
            let result = await addCompany();
            if (result !== null) {
                if (subdomainUpdatesData.registerSubdomain) {
                    try {
                        await postApi("adminapi", "/subdomain", {
                            body: {
                                newSubdomain: subdomainUpdatesData.newSubdomain,
                                oldSubdomain: subdomainUpdatesData.oldSubdomain
                            }
                        });

                        //if oldsubdomain exists, create cache of services, skills, companylocations.
                        //read cache items of oldsubdomain, and create cache entries for the newSubdomain
                        if (subdomainUpdatesData.oldSubdomain) {
                            const response = await graphql(
                                graphqlOperation(
                                    ` 
                                  query ListRefDatas(
                                    $refType: ID
                                    $refName: ModelStringKeyConditionInput
                                    $filter: ModelRefDataFilterInput
                                    $limit: Int
                                    $nextToken: String
                                    $sortDirection: ModelSortDirection
                                  ) {
                                    listRefDatas(
                                      refType: $refType
                                      refName: $refName
                                      filter: $filter
                                      limit: $limit
                                      nextToken: $nextToken
                                      sortDirection: $sortDirection
                                    ) {
                                      items {
                                        refValue
                                        overrideValue
                                        refName
                                        refType
                                      }
                                      nextToken
                                    }
                                  }
                                `,
                                    {
                                        refType: `domain|${oldInfo[0].subdomain}`,
                                        refName: { beginsWith: "data" }
                                    }
                                )
                            );
                            for (let d of response.data.listRefDatas.items) {
                                if (
                                    d.refValue === "services" ||
                                    d.refValue === "skills" ||
                                    d.refValue === "companyLocations"
                                ) {
                                    d.refType = `domain|${subdomain}`;
                                    await graphql(
                                        graphqlOperation(
                                            mutations.createRefData,
                                            {
                                                input: d
                                            }
                                        )
                                    );
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
                setMbxUser({
                    ...mbxUser,
                    company: {
                        ...mbxUser.company,
                        ProviderRestrictionConfig: JSON.stringify({
                            canProviderSeeClientName: canProviderSeeClientName,
                            canProviderSeeClientEmail:
                                canProviderSeeClientEmail,
                            canProviderSeeClientPhone:
                                canProviderSeeClientPhone,
                            canProviderSetMaxTravelTime:
                                canProviderSetMaxTravelTime
                        })
                    }
                });

                setShowLoading(false);
                setSnackMsg("Company successfully saved.");
                setMsgOpen(true);
                if (state.mode === "Add")
                    setTimeout(() => {
                        navigate("/companies/edit");
                        actions.setId(result.id); //companyId (new company)
                        actions.setMode("Edit");
                        props.assignModalTitleCompanyName(name);
                        setReplyEmailAddress(emailaddress);
                    }, 2000);
                else props.onClose();
            }
        }
    }

    function getSubdomainPrefix(subdomain) {
        //.gomarketbox.com
        return subdomain.substring(
            0,
            subdomain.lastIndexOf(".gomarketbox.com")
        );
    }

    function handleMsgClose(event, reason) {
        setMsgOpen(false);
    }

    const handleOnClose = () => {
        setShowFeatureGateDialog(false);
    };

    // handle name change
    const handleChangeName = (e) => {
        setName(e.target.value);
    };

    // handle contactname change
    const handleChangeContactName = (e) => {
        const inputValue = e.target.value;
        const capitalizedName = inputValue
            .split(" ")
            .map((word) =>
                word
                    .split("-")
                    .map(
                        (part) =>
                            part.charAt(0).toUpperCase() +
                            part.slice(1).toLowerCase()
                    )
                    .join("-")
            )
            .join(" ");

        setContactName(capitalizedName);
    };

    // handle currency change
    const handleChangeCurrency = (e, value) => {
        setCurrency(value.value);
    };

    // handle EmailAddress change
    const handleChangeEmailAddress = (e) => {
        const email = e.target.value.trim().toLowerCase();
        setEmailAddress(email);
    };

    const handleChangeReplyEmailAddress = (e) => {
        setReplyEmailAddress(e.target.value);
    };

    const handleChangeShowTipOption = (e) => {
        setShowTipOption(e.target.checked);
    };

    function handleAddressDialogSave(
        addressOneLine,
        street,
        city,
        state,
        postalCode,
        country,
        lat,
        lon,
        checked
    ) {
        setAddressOneLine(addressOneLine ? addressOneLine : null);
        setAddressStreet(street ? street : null);
        setAddressCity(city ? city : null);
        setAddressState(state ? state : null);
        setPostalCode(postalCode ? postalCode : null);
        setCountry(country);
        setCountrycode3166alpha2(getCountryCode(country).toLowerCase());
        setLongitude(lon);
        setLatitude(lat);
    }

    const setSwitches = ({ target: { name, checked } }) => {
        setValues((oldValues) => ({
            ...oldValues,
            [name]: checked
        }));
    };

    const handlePackagesOnlySwitch = (value) => {
        setOffersPackagesOnly(value);
        if (value) {
            setMultipleQty(false);
            setMultipleServices(false);
        }
    };

    const handleChooseSpecificProviderSwitch = (value) => {
        setProviderAgnosticFlow(value);
        if (providerMustAcceptAppt && value) setProviderMustAcceptAppt(false);
        if (value) {
            setSingleApptOnly(true);
            setOffersPackagesOnly(false);
            setOffersForeverAppt(false);
            setCanClientReschedule(false);
            setForceRepeatingPackages(false);
            setMultipleQty(false);
            setMultipleServices(false);
        }
    };

    const handleChangeTime = (e) => {
        const value = e.target.value;
        setBookingIntervalMinutes(value ? Math.ceil(value * 60) : 0);
    };

    function DisplayProviderTimeout() {
        if (providerMustAcceptAppt) {
            return (
                <>
                    <Grid container item xs={12} sm={12}>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={3}
                            sx={{ paddingRight: "9px" }}
                        >
                            <FormControl required fullWidth>
                                <TextField
                                    variant="outlined"
                                    id="select-prov-timeout"
                                    label="Primary provider timeout"
                                    type="number"
                                    className={classes.textField}
                                    value={selectProvTimeout}
                                    onChange={(e) =>
                                        setSelectProvTimeout(e.target.value)
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                disableTypography
                                            >
                                                mins
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <InfoTooltip title="Time given to the selected provider to accept or decline a new booking request – if not accepted in this window and no other providers are available, it will automatically expire and the client's card will not be charged" />
                    </Grid>
                    <Grid container item xs={12} sm={12} pb={"1px"}>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={3}
                            sx={{ paddingRight: "9px" }}
                        >
                            <FormControl required fullWidth>
                                <TextField
                                    variant="outlined"
                                    id="add-prov-timeout"
                                    label="Secondary providers timeout"
                                    type="number"
                                    className={classes.textField}
                                    value={addProvTimeout}
                                    onChange={(e) =>
                                        setAddProvTimeout(e.target.value)
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                disableTypography
                                            >
                                                mins
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        {/* <Tooltip title="Time given to additional providers to accept or decline a booking request after the primary provider either declined or did not respond in time – this is on a first come, first served basis and if not accepted in this window by any of the providers, it will automatically expire and the client's card will not be charged">
                            <QuestionMarkIcon
                                sx={getToolTipStyle()}
                                color="primary"
                            />
                        </Tooltip> */}
                        <InfoTooltip title="Time given to additional providers to accept or decline a booking request after the primary provider either declined or did not respond in time – this is on a first come, first served basis and if not accepted in this window by any of the providers, it will automatically expire and the client's card will not be charged" />

                        {/* <Grid container item xs={12} sm={12}>
                            <FormHelperText>
                                <Typography variant="helperText">
                                    Time given to additional providers to accept
                                    or decline a new order after the primary
                                    provider either declined or did not respond
                                    in time {`\u2014`} this is on a first come
                                    first served basis (if an order is not
                                    accepted in this window by any of the
                                    providers, it automatically expires and the
                                    client's card is not charged)
                                </Typography>
                            </FormHelperText>
                        </Grid> */}
                    </Grid>
                </>
            );
        }
    }

    async function uploadSecvalue() {
        const companyId = state.id;

        try {
            const body = {
                companyId,
                valueType: "SS",
                value: newSecvalue
            };
            let result;
            if (secvalue) {
                //if current value exists then update it
                result = await putApi("adminapi", `/secval`, {
                    body
                });
            } else {
                //create/upload new value
                result = await postApi("adminapi", `/secval`, {
                    body
                });
            }
            if (result && result.success) {
                await readStripeSecvalue(companyId);
            }
            setShowSecvalUploadDialog(false);
            setSnackMsg("Saved your Stripe secret key successfully.");
            setMsgOpen(true);
            setMsgOpen(true);
        } catch (e) {
            setShowSecvalUploadDialog(false);
            setSnackMsg("Could not upload the Stripe secret key.");
            setMsgOpen(true);
            console.log("error", e);
        }
    }

    function showCompanyHeading() {
        if (
            welcomeMessageState &&
            welcomeMessageState.hasActiveSchedule &&
            welcomeMessageState.companyIsActive
        )
            return true;
        return false;
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    if (isLoading) {
        return (
            <DialogContent sx={{ minHeight: "342px" }}>
                <Backdrop
                    sx={{
                        backgroundColor: "transparent !important"
                    }}
                    open={true}
                >
                    <CircularProgress color="primary" />
                </Backdrop>
            </DialogContent>
        );
    }

    // Check if all fields have values directly in the button
    const isSubmitDisabled = !(
        subscriptionLevel &&
        emailaddress &&
        contactname &&
        name &&
        currency
    );

    return (
        <>
            <DialogContent>
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                    open={msgOpen}
                    autoHideDuration={3000}
                    onClose={handleMsgClose}
                    ContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">{snackMsg}</span>}
                />
                <Backdrop className={classes3.backdrop} open={showLoading}>
                    <CircularProgress color="primary" />
                </Backdrop>
                <Dialog
                    open={showStripeConnectResult}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" sx={{ mb: "18px" }}>
                        {stripeConnectEnabled
                            ? " Success!"
                            : " Stripe Connect not set up"}
                    </DialogTitle>
                    <DialogContent>
                        {stripeConnectEnabled && (
                            <>
                                <DialogContentText>
                                    Your Stripe account has been setup. You are
                                    ready to collect payments through MarketBox.
                                </DialogContentText>
                            </>
                        )}
                        {!stripeConnectEnabled && !stripeConnectError && (
                            <DialogContentText>
                                Use the <b>‘Connect with Stripe’</b> button to
                                finish setting up your account.
                            </DialogContentText>
                        )}{" "}
                        {stripeConnectError && (
                            <DialogContentText>
                                We have encountered an error while trying to
                                connect to your Stripe Account. Please contact
                                MarketBox Support.
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setShowStripeConnectResult(false)}
                            color="primary"
                            variant="contained"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={showStripeConnectModal}>
                    <DialogTitle>Connect Stripe</DialogTitle>
                    <DialogContent sx={{ mt: "18px" }}>
                        {(!stripeConnectedAccount || !stripeConnectEnabled) && (
                            <Grid
                                item
                                style={{
                                    display:
                                        window.innerWidth > 400 ? "flex" : ""
                                }}
                            >
                                <Grid
                                    item
                                    xs={6}
                                    style={{
                                        maxWidth: "100%",
                                        width: "100%"
                                    }}
                                >
                                    <FormControl required>
                                        <TextField
                                            style={{
                                                width:
                                                    window.innerWidth > 400
                                                        ? "340px"
                                                        : "100%"
                                            }}
                                            size="small"
                                            variant="outlined"
                                            id="publishablestripekey"
                                            label="Stripe publishable key"
                                            className={classes.textField}
                                            value={stripeKey}
                                            onChange={(e) =>
                                                setStripeKey(e.target.value)
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                        {companyId &&
                            (!stripeConnectedAccount ||
                                !stripeConnectEnabled) && (
                                <>
                                    <Grid
                                        item
                                        style={{
                                            display:
                                                window.innerWidth > 400
                                                    ? "flex"
                                                    : ""
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={5}
                                            style={{
                                                maxWidth: "100%",
                                                width: "100%"
                                            }}
                                        >
                                            <FormControl
                                                required
                                                fullWidth
                                                className={classes.formControl}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    id="sskey"
                                                    label="Stripe secret key"
                                                    className={
                                                        classes.textField
                                                    }
                                                    value={
                                                        secvalue
                                                            ? secvalue
                                                            : " "
                                                    }
                                                    style={{
                                                        width:
                                                            window.innerWidth >
                                                            400
                                                                ? "340px"
                                                                : "100%"
                                                    }}
                                                    readOnly
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <FormControl
                                                                    required
                                                                    fullWidth
                                                                    className={
                                                                        classes.formControl
                                                                    }
                                                                >
                                                                    <div></div>
                                                                    <Button
                                                                        component="span"
                                                                        m={1}
                                                                        variant="text"
                                                                        color="primary"
                                                                        onClick={() =>
                                                                            setShowSecvalUploadDialog(
                                                                                true
                                                                            )
                                                                        }
                                                                        style={{
                                                                            transform:
                                                                                window.innerWidth >
                                                                                400
                                                                                    ? "translate(7px,-4px)"
                                                                                    : "translate(0px,-4px)"
                                                                        }}
                                                                    >
                                                                        Enter
                                                                        Key
                                                                    </Button>
                                                                </FormControl>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setShowStripeConnectModal(false)}
                            variant="contained"
                            color="primary"
                        >
                            Close
                        </Button>{" "}
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showSecvalUploadDialog}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">
                        Enter Secret Key
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: "0px" }}>
                        <Grid item>
                            {/* <DialogContentText>
                                Please enter your Stripe account's secret key in the
                                box below and click Save. This action will replace
                                your currently configured Stripe secret key used by
                                your Marketbox account.
                            </DialogContentText> */}
                            <Typography
                                style={{
                                    paddingBottom: "16px",
                                    fontSize: "13px"
                                }}
                            >
                                Your Stripe Secret key will be securely stored
                                and is kept strictly confidential.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Grid item>
                                <TextField
                                    variant="outlined"
                                    id="outlined-multiline-static"
                                    multiline
                                    value={newSecvalue}
                                    fullWidth
                                    size="small"
                                    label="Please enter key here."
                                    onChange={(e) =>
                                        setNewSecvalue(e.target.value)
                                    }
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setShowSecvalUploadDialog(false)}
                            color="primary"
                            variant="outlined"
                        >
                            Close
                        </Button>{" "}
                        <Button
                            onClick={async () => await uploadSecvalue()}
                            color="primary"
                            variant="contained"
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
                <FeatureGateDialog
                    open={showFeatureGateDialog}
                    handleOnClose={handleOnClose}
                />

                {tabValue === 0 && (
                    <>
                        <Grid
                            container
                            spacing={2.25}
                            sx={{ marginTop: "18px" }}
                        >
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    id="name"
                                    label="Company name"
                                    className={classes.textField}
                                    value={name}
                                    size="small"
                                    fullWidth
                                    onChange={handleChangeName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl
                                    fullWidth
                                    required
                                    disabled={!userIsMarketBoxAdmin}
                                >
                                    <Autocomplete
                                        disabled={!userIsMarketBoxAdmin}
                                        id="subscription-level-enabled"
                                        fullWidth
                                        options={subscriptionLevelConst}
                                        disableClearable={true}
                                        classes={{
                                            option: classes.option
                                        }}
                                        autoHighlight
                                        getOptionLabel={(option) =>
                                            option.label
                                        }
                                        renderOption={(props, option) => (
                                            <li {...props}>{option.label}</li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                                label="Subscription"
                                                variant="outlined"
                                            />
                                        )}
                                        defaultValue={subscriptionLevelConst.find(
                                            (item) =>
                                                item.value === subscriptionLevel
                                        )}
                                        onChange={(e) => {
                                            const val = e.target.innerText;
                                            if (val === "Free Trial") {
                                                setSubscriptionLevel(
                                                    "FREE_TRIAL_BASIC"
                                                );
                                            } else if (val === "Starter") {
                                                setSubscriptionLevel("BASIC");
                                            } else if (val === "Professional") {
                                                setSubscriptionLevel(
                                                    "PROFESSIONAL"
                                                );
                                            } else if (val === "Enterprise") {
                                                setSubscriptionLevel(
                                                    "ENTERPRISE"
                                                );
                                            } else if (
                                                val === "Sole Operator"
                                            ) {
                                                setSubscriptionLevel(
                                                    "SOLE_OPERATOR"
                                                );
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            {loggedInUser?.role === "MARKETBOX_ADMIN" && (
                                <Grid
                                    container
                                    alignItems={"center"}
                                    item
                                    xs={12}
                                    sm={3}
                                >
                                    <Grid>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={active}
                                                    onChange={(event) =>
                                                        setActive(
                                                            event.target.checked
                                                        )
                                                    }
                                                    value="active"
                                                    color="primary"
                                                    inputProps={{
                                                        "aria-label":
                                                            "primary checkbox"
                                                    }}
                                                />
                                            }
                                            label="Active"
                                        />
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    id="contactname"
                                    label="Primary contact"
                                    className={classes.textField}
                                    fullWidth
                                    value={contactname}
                                    onChange={handleChangeContactName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    id="email"
                                    label="Email"
                                    className={classes.textField}
                                    fullWidth
                                    value={emailaddress}
                                    onChange={handleChangeEmailAddress}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl required fullWidth>
                                    <AddressEntryTextBox
                                        style={{
                                            margin: "0",
                                            width: "100%"
                                        }}
                                        fromSettingsModal={true}
                                        setAddress={handleAddressDialogSave}
                                        autocompleteService={
                                            autocompleteService
                                        }
                                        addressOneLine={addressOneLine}
                                        id="addressoneline"
                                        label={"Company address"}
                                        value={addressOneLine}
                                        tooltipTitle={
                                            "This address will be used to determine the default time zone for the company and will be used for all billing purposes"
                                        }
                                        infoTooltip={true}
                                        sx={{
                                            alignContent: "center",
                                            flexWrap: "wrap",
                                            marginRight: "16px"
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl required fullWidth>
                                    <Autocomplete
                                        style={{ width: "100%" }}
                                        id="currency"
                                        options={currencies}
                                        disableClearable={true}
                                        classes={{
                                            option: classes.option
                                        }}
                                        autoHighlight
                                        getOptionLabel={(option) =>
                                            option.label
                                        }
                                        renderOption={(props, option) => (
                                            <li {...props}>{option.label}</li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                fullWidth
                                                {...params}
                                                label="Currency"
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                        defaultValue={currencies.find(
                                            (item) => item.value === currency
                                        )}
                                        onChange={handleChangeCurrency}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </>
                )}

                {tabValue === 1 && (
                    <Grid
                        container
                        item
                        spacing={2.25}
                        xs={12}
                        sm={12}
                        sx={{
                            marginTop: "0px",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            [theme.breakpoints.up("md")]: {
                                minWidth: "696px"
                            }
                        }}
                    >
                        <Grid item xs={12}>
                            <Typography variant="largerSubHeading">
                                Smart Clusters (mobile)
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={
                                    !showSuggestionSettings()
                                        ? classesnew.marginFeatureGateCustom
                                        : classesnew.marginBottomNone
                                }
                                onClick={() => {
                                    if (!showSuggestionSettings()) {
                                        setShowFeatureGateDialog(true);
                                    }
                                }}
                                control={
                                    <Switch
                                        disabled={!showSuggestionSettings()}
                                        checked={timeSuggestionsEnabled}
                                        onChange={(event) =>
                                            setTimeSuggestionsEnabled(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label={
                                    !showSuggestionSettings() ? (
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            }}
                                        >
                                            <Typography>
                                                Use AI-optimized time
                                                suggestions on online booking
                                                page
                                            </Typography>
                                            <StarsIcon color="notice" />
                                        </Grid>
                                    ) : (
                                        "Use AI-optimized time suggestions on online booking page"
                                    )
                                }
                            />
                            <InfoTooltip
                                title="Based on the address that a client enters,
                                    we find existing future bookings nearby and
                                    show available times on the same day,
                                    adjacent to the existing ones, in order to
                                    minimize provider travel time between
                                    bookings; these suggestions are always on
                                    when making bookings via the back office."
                            />
                        </Grid>
                        {timeSuggestionsEnabled && (
                            <>
                                <Grid item xs={12} sm={12}>
                                    <FormControlLabel
                                        onClick={() => {
                                            if (!showSuggestionSettings()) {
                                                setShowFeatureGateDialog(true);
                                            }
                                        }}
                                        control={
                                            <Switch
                                                disabled={
                                                    !showSuggestionSettings()
                                                }
                                                checked={
                                                    timeSuggestionsForceClientAccept
                                                }
                                                onChange={(event) =>
                                                    setTimeSuggestionsForceClientAccept(
                                                        event.target.checked
                                                    )
                                                }
                                                value="active"
                                                color="primary"
                                                inputProps={{
                                                    "aria-label":
                                                        "primary checkbox"
                                                }}
                                            />
                                        }
                                        label="Force clients to accept AI-optimized time suggestions"
                                    />
                                    <InfoTooltip title="Clients must select one of the AI time suggestions and cannot select an unoptimized time – if off, clients can bypass the AI time suggestions and book any available time, which may be less convenient for providers" />
                                </Grid>
                                <Grid container item xs={12} sm={12}>
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        sm={6}
                                        sx={{ paddingRight: "9px" }}
                                    >
                                        <FormControl fullWidth required>
                                            <Box
                                                gap={1.125}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    label="Anchor time for an empty day"
                                                    select
                                                    onChange={(e) => {
                                                        setEmptyDaySlotsMedhod(
                                                            e.target.value
                                                        );
                                                    }}
                                                    value={emptyDaySlotsMethod}
                                                    onClick={() =>
                                                        !showSuggestionSettings() &&
                                                        setShowFeatureGateDialog(
                                                            true
                                                        )
                                                    }
                                                    disabled={
                                                        !showSuggestionSettings()
                                                    }
                                                    sx={{
                                                        minWidth: "330px"
                                                    }}
                                                >
                                                    {emptyDayAnchorTimeMethodOptions.map(
                                                        (anchorTimeMethod) => (
                                                            <MenuItem
                                                                value={
                                                                    anchorTimeMethod.value
                                                                }
                                                            >
                                                                {
                                                                    anchorTimeMethod.text
                                                                }
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </TextField>
                                                {emptyDaySlotsMethod ===
                                                    SPECIFIC_TIME && (
                                                    <TextField
                                                        variant="outlined"
                                                        label="Anchor time"
                                                        select
                                                        onChange={(e) => {
                                                            setEmptyDayFirstBookingTime(
                                                                e.target.value
                                                            );
                                                        }}
                                                        value={
                                                            emptyDayFirstBookingTime
                                                                ? emptyDayFirstBookingTime
                                                                : "12:00"
                                                        }
                                                        onClick={() =>
                                                            !showSuggestionSettings() &&
                                                            setShowFeatureGateDialog(
                                                                true
                                                            )
                                                        }
                                                        disabled={
                                                            !showSuggestionSettings()
                                                        }
                                                        sx={{
                                                            minWidth: "156px",
                                                            marginLeft:
                                                                emptyDaySlotsMethod ===
                                                                    SPECIFIC_TIME &&
                                                                "9px"
                                                        }}
                                                    >
                                                        {anchorTimeOptions.map(
                                                            (anchorTime) => (
                                                                <MenuItem
                                                                    value={
                                                                        anchorTime.value
                                                                    }
                                                                >
                                                                    {
                                                                        anchorTime.text
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </TextField>
                                                )}
                                                <InfoTooltip
                                                    title={`The first booking on an empty day for a provider can be placed any time and will be used as an "anchor" point to build the day's schedule around:\n
                                        "Any time" = show available times once an hour from the start of the availability block\n
                                        "First and last" = show the first and last available times in any availability block (a day may have multiple availability blocks)\n
                                        "Specific time" = show available times at the selected time and plus / minus one hour`}
                                                />
                                                {!showSuggestionSettings() && (
                                                    <Grid
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <StarsIcon color="notice" />
                                                    </Grid>
                                                )}
                                            </Box>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={12}
                                    gap={1.125}
                                >
                                    <Grid container item xs={12} sm={3}>
                                        <FormControl fullWidth required>
                                            <Box
                                                gap={2}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row"
                                                }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    label="Max travel time"
                                                    select
                                                    onChange={(e) => {
                                                        setCompanyMaxTravelTime(
                                                            e.target.value
                                                        );
                                                    }}
                                                    value={companyMaxTravelTime}
                                                    onClick={() =>
                                                        !showSuggestionSettings() &&
                                                        setShowFeatureGateDialog(
                                                            true
                                                        )
                                                    }
                                                    disabled={
                                                        !showSuggestionSettings()
                                                    }
                                                    sx={{
                                                        minWidth: "160px"
                                                    }}
                                                >
                                                    {maxTravelTimeMinutesBetweenBookings.map(
                                                        (minutes) => (
                                                            <MenuItem
                                                                value={minutes}
                                                            >
                                                                {`${minutes} mins`}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </TextField>
                                                {!showSuggestionSettings() && (
                                                    <Grid
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <StarsIcon color="notice" />
                                                    </Grid>
                                                )}
                                            </Box>
                                        </FormControl>
                                    </Grid>
                                    <InfoTooltip
                                        title={`Maximum travel time between bookings within a provider's travel zone – the provider's overall coverage area can be large, but travel time between bookings is capped`}
                                    />
                                </Grid>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={12}
                                    gap={1.125}
                                >
                                    <Grid container item xs={12} sm={3}>
                                        <FormControl fullWidth required>
                                            <Box
                                                gap={2}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row"
                                                }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    label="Buffer time"
                                                    select
                                                    onClick={() =>
                                                        !showSuggestionSettings() &&
                                                        setShowFeatureGateDialog(
                                                            true
                                                        )
                                                    }
                                                    onChange={(e) => {
                                                        setCompanyBufferTime(
                                                            e.target.value
                                                        );
                                                    }}
                                                    value={companyBufferTime}
                                                    disabled={true}
                                                    sx={{
                                                        minWidth: "160px"
                                                    }}
                                                >
                                                    {bufferTimeMinutesBetweenBookings.map(
                                                        (minutes) => (
                                                            <MenuItem
                                                                value={minutes}
                                                            >
                                                                {`${minutes} mins`}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </TextField>
                                                {!showSuggestionSettings() && (
                                                    <Grid
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <StarsIcon color="notice" />
                                                    </Grid>
                                                )}
                                            </Box>
                                        </FormControl>
                                    </Grid>
                                    <InfoTooltip
                                        title={`Buffer time between bookings to account for finding parking, gathering required materials, etc – this will be added to max travel time to calculate suggested times (currently a fixed value of 10 mins, but ability to control this separately is coming soon!)`}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={
                                                    canProviderSetMaxTravelTime
                                                }
                                                onChange={(e) =>
                                                    setCanProviderSetMaxTravelTime(
                                                        e.target.checked
                                                    )
                                                }
                                                value="providersCanSetTravelTime"
                                                color="primary"
                                                name="providersCanSetTravelTime"
                                                inputProps={{
                                                    "aria-label":
                                                        "primary checkbox"
                                                }}
                                            />
                                        }
                                        label="Providers can set their own max travel time"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                        onClick={() => {
                                            setSelectedUserId(mbxUser.username);
                                            setUserModalTabValue(1);
                                            setOpenUserDialog(true);
                                            setOpenAvailabilityDialog(true);
                                        }}
                                    >
                                        Set up Travel Zones
                                    </Button>
                                </Grid>
                            </>
                        )}

                        <Grid item variant="subHeading">
                            <Typography variant="largerSubHeading">
                                Bookings
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        {!companyIsSoleOperator() && (
                            <Grid
                                container
                                item
                                xs={12}
                                sx={{
                                    alignItems: "center"
                                }}
                            >
                                <Grid container item xs={6} pr={1.125}>
                                    <FormControl fullWidth>
                                        <TextField
                                            size="small"
                                            select
                                            variant="outlined"
                                            label="Provider assignment"
                                            onChange={(e) => {
                                                handleChooseSpecificProviderSwitch(
                                                    e.target.value
                                                );
                                            }}
                                            value={providerAgnosticFlow}
                                        >
                                            <MenuItem
                                                value={true}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography>
                                                    System auto-assigns nearest
                                                    provider
                                                </Typography>
                                            </MenuItem>
                                            <MenuItem
                                                value={false}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography>
                                                    Clients can select specific
                                                    provider
                                                </Typography>
                                            </MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid container item xs={2}>
                                    <InfoTooltip title="Clients can either view all provider profiles and choose a specific person for the service or the system will find the most suitable provider automatically based on availability" />
                                </Grid>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                required
                                sx={{
                                    height: "20px",
                                    "& .MuiFormControlLabel-asterisk": {
                                        display: "none"
                                    }
                                }}
                                control={
                                    <Switch
                                        checked={addServiceFee}
                                        onChange={(e) =>
                                            setAddserviceFee(e.target.checked)
                                        }
                                        value="serviceFee"
                                        color="primary"
                                        name="serviceFee"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Charge service fee"
                            />
                            <InfoTooltip title="For single appointments and packages, this is applied once to the entire order and for recurring bookings, this is applied for each appointment" />
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            sx={{ paddingTop: "0px !important" }}
                        >
                            <Grid
                                container
                                item
                                spacing={2.25}
                                xs={12}
                                justifyContent="flex-start"
                            >
                                <Grid item sm={3}>
                                    <Autocomplete
                                        options={["DOLLAR", "PERCENTAGE"]}
                                        disableClearable={true}
                                        disabled={!addServiceFee}
                                        value={serviceFeeType}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                                label="Service fee type"
                                                size="small"
                                                value={
                                                    serviceFeeType
                                                        ? capitalizeFirstLetter(
                                                              serviceFeeType.toLowerCase()
                                                          )
                                                        : ""
                                                }
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                {capitalizeFirstLetter(
                                                    option.toLowerCase()
                                                )}
                                            </li>
                                        )}
                                        onChange={(e, newValue) => {
                                            if (newValue)
                                                setServiceFeeType(newValue);
                                        }}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl margin="none" required>
                                        <TextField
                                            variant="outlined"
                                            id="serviceFeeAmount"
                                            label="Amount"
                                            size="small"
                                            type="number"
                                            InputProps={{
                                                startAdornment:
                                                    serviceFeeType ===
                                                        "DOLLAR" && (
                                                        <InputAdornment
                                                            position="start"
                                                            disableTypography
                                                        >
                                                            $
                                                        </InputAdornment>
                                                    ),
                                                endAdornment: serviceFeeType ===
                                                    "PERCENTAGE" && (
                                                    <InputAdornment
                                                        position="end"
                                                        disableTypography
                                                    >
                                                        %
                                                    </InputAdornment>
                                                )
                                            }}
                                            value={serviceFeeAmount}
                                            inputProps={{
                                                min: "1",
                                                step: "1"
                                            }}
                                            onChange={(e) =>
                                                setServiceFeeAmount(
                                                    e.target.value
                                                )
                                            }
                                            disabled={!addServiceFee}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3} />
                                <Grid item xs={12} sm={3} />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={values.remote}
                                        onChange={setSwitches}
                                        value="remote"
                                        name="remote"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Allow in-home appointments"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} direction={"column"}>
                            <FormControlLabel
                                onClick={() => {
                                    if (
                                        isFeatureGated(
                                            subscriptionLevel,
                                            "PriceByLocation"
                                        )
                                    ) {
                                        setShowFeatureGateDialog(true);
                                    }
                                }}
                                control={
                                    <Switch
                                        checked={currencyBasedOnLocation}
                                        disabled={isFeatureGated(
                                            subscriptionLevel,
                                            "PriceByLocation"
                                        )}
                                        onChange={(event) => {
                                            setCurrencyBasedOnLocation(
                                                event.target.checked
                                            );
                                        }}
                                        value="currencyBasedOnLocation"
                                        color="primary"
                                        name="currency"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "PriceByLocation"
                                    ) ? (
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            }}
                                        >
                                            <Typography>
                                                Currency based on location
                                            </Typography>
                                            <StarsIcon color="notice" />
                                        </Grid>
                                    ) : (
                                        "Currency based on country"
                                    )
                                }
                                classes={{
                                    label: classes.tableCellLabel
                                }}
                            />
                            <InfoTooltip title="Charge clients in the currency of their country without conversion – if off, clients will be charged in your company's master currency" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={singleApptOnly}
                                        onChange={(event) => {
                                            if (
                                                isFeatureGated(
                                                    subscriptionLevel,
                                                    "DisableSingleAppointments"
                                                )
                                            ) {
                                                setShowFeatureGateDialog(true);
                                            } else {
                                                setSingleApptOnly(
                                                    event.target.checked
                                                );
                                            }
                                        }}
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Allow only single appointments"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "RecurringAppointments"
                                    )
                                        ? classesnew.marginFeatureGateCustom
                                        : classesnew.marginBottomNone
                                }
                                control={
                                    <Switch
                                        disabled={singleApptOnly}
                                        checked={offersForeverAppt}
                                        onChange={(event) => {
                                            setOffersForeverAppt(
                                                event.target.checked
                                            );
                                        }}
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "RecurringAppointments"
                                    ) ? (
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            }}
                                        >
                                            <Typography>
                                                Allow only recurring bookings
                                            </Typography>
                                            <StarsIcon color="notice" />
                                        </Grid>
                                    ) : (
                                        "Allow only recurring bookings"
                                    )
                                }
                                classes={{
                                    label: classes.tableCellLabel
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "Packages"
                                    )
                                        ? classesnew.marginFeatureGateCustom
                                        : classesnew.marginBottomNone
                                }
                                onClick={() => {
                                    if (
                                        isFeatureGated(
                                            subscriptionLevel,
                                            "Packages"
                                        )
                                    ) {
                                        setShowFeatureGateDialog(true);
                                    }
                                }}
                                control={
                                    <Switch
                                        disabled={singleApptOnly}
                                        checked={offersPackagesOnly}
                                        onChange={(event) => {
                                            handlePackagesOnlySwitch(
                                                event.target.checked
                                            );
                                        }}
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "Packages"
                                    ) ? (
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            }}
                                        >
                                            <Typography>
                                                Allow only packages
                                            </Typography>
                                            <StarsIcon color="notice" />
                                        </Grid>
                                    ) : (
                                        "Allow only packages"
                                    )
                                }
                                classes={{
                                    label: classes.tableCellLabel
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "Packages"
                                    )
                                        ? classesnew.marginFeatureGateCustom
                                        : classesnew.marginBottomNone
                                }
                                control={
                                    <Switch
                                        disabled={singleApptOnly}
                                        checked={forceRepeatingPackages}
                                        onChange={(event) => {
                                            setForceRepeatingPackages(
                                                event.target.checked
                                            );
                                        }}
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label={
                                    isFeatureGated(
                                        subscriptionLevel,
                                        "Packages"
                                    ) ? (
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1
                                            }}
                                        >
                                            <Typography>
                                                Force repeating package sessions{" "}
                                                <b>once per week</b>
                                            </Typography>
                                            <StarsIcon color="notice" />
                                        </Grid>
                                    ) : (
                                        <span>
                                            Force repeating package sessions{" "}
                                            <b>once per week</b>
                                        </span>
                                    )
                                }
                                classes={{
                                    label: classes.tableCellLabel
                                }}
                            />
                            <InfoTooltip title="Clients will be forced to book repeating lessons for the same day and time every week – if off, clients will also be able to cherry-pick single lessons with no repeating pattern" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={multipleServices}
                                        disabled={
                                            offersPackagesOnly ||
                                            providerAgnosticFlow
                                        }
                                        onChange={(event) =>
                                            setMultipleServices(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Allow multiple services per booking"
                            />
                            <InfoTooltip title="Multiple services will be stacked on the same day one after the other – not compatible with packages and recurring bookings" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={multipleQty}
                                        disabled={
                                            offersPackagesOnly ||
                                            providerAgnosticFlow
                                        }
                                        onChange={(event) =>
                                            setMultipleQty(event.target.checked)
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Allow multiple quantity of the same service per booking"
                            />
                            <InfoTooltip title="Multiple quantity of the same service will be stacked on the same day one after the other – not compatible with packages and recurring bookings" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={providerCanCancelAppt}
                                        onChange={(event) =>
                                            setProviderCanCancelAppt(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Providers can cancel bookings"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={canProviderReschedule}
                                        onChange={(event) =>
                                            setCanProviderReschedule(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Providers can reschedule bookings"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={canProviderSeeClientName}
                                        onChange={(event) =>
                                            setCanProviderSeeClientName(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Providers can see client last names"
                            />
                            <InfoTooltip title="Providers will see client last names on all relevant pages in the admin console and in all emails and SMS messages – if off, only the first letter of the client's last name will be shown" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={canProviderSeeClientEmail}
                                        onChange={(event) =>
                                            setCanProviderSeeClientEmail(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Providers can see client email addresses"
                            />
                            <InfoTooltip title="Providers will see client email addresses on all relevant pages in the admin console and in all emails" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={canProviderSeeClientPhone}
                                        onChange={(event) =>
                                            setCanProviderSeeClientPhone(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Providers can see client phone numbers"
                            />
                            <InfoTooltip title="Providers will see client phone numbers on all relevant pages in the admin console and in all emails" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        disabled={
                                            providerAgnosticFlow ||
                                            providerMustAcceptAppt
                                        }
                                        checked={canClientReschedule}
                                        onChange={(event) =>
                                            setCanClientReschedule(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Clients can reschedule bookings"
                            />
                            <InfoTooltip title="Not compatible with Accept / Decline" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                className={classesnew.marginBottomNone}
                                control={
                                    <Switch
                                        checked={refundOnBookingCancellation}
                                        onChange={(event) =>
                                            setRefundOnBookingCancellation(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Automatically process refunds for cancelled bookings"
                            />
                            <InfoTooltip title="When a client or admin cancels a booking outside the minimum cancellation notice period, refund will be processed automatically." />
                        </Grid>
                        <Grid container item xs={12} sm={12}>
                            <Grid
                                item
                                xs={12}
                                sm={3}
                                sx={{
                                    paddingTop: "8px",
                                    paddingRight: "13.5px"
                                }}
                            >
                                <FormControl required fullWidth>
                                    <TextField
                                        variant="outlined"
                                        id="bookingIntervalMinutes"
                                        label="Min. booking notice"
                                        size="small"
                                        defaultValue={(
                                            bookingIntervalMinutes / 60
                                        ).toFixed(2)}
                                        type="number"
                                        onChange={handleChangeTime}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    disableTypography
                                                >
                                                    hours
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            spacing={2.25}
                            pt={"0 !important"}
                        >
                            <Grid container item xs={12} sm={3}>
                                <FormControl required fullWidth>
                                    <TextField
                                        variant="outlined"
                                        id="cancelPolicyMinutesBefore"
                                        label="Min. cancel notice"
                                        size="small"
                                        defaultValue={(
                                            cancelPolicyMinsBefore / 60
                                        ).toFixed(2)}
                                        type="number"
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setCancelPolicyMinsBefore(
                                                val ? Math.ceil(val * 60) : 0
                                            );
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    disableTypography
                                                >
                                                    hours
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} pl={`9px !important`}>
                                <InfoTooltip title="This controls both the cancellation and the reschedule threshold – clients can still cancel inside the threshold, but they will not get refunded" />
                            </Grid>
                            <Grid item xs={12} sm={3} />
                            <Grid item xs={12} sm={3} />
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            spacing={2.25}
                            pt={"0 !important"}
                        >
                            <Grid container item xs={12} sm={3}>
                                <FormControl
                                    required
                                    fullWidth
                                    className={classes.formControl}
                                >
                                    <TextField
                                        variant="outlined"
                                        label="Buffer time"
                                        size="small"
                                        select
                                        onChange={(e) => {
                                            setTravelTime(e.target.value);
                                        }}
                                        value={travelTime}
                                        disabled={timeSuggestionsEnabled}
                                    >
                                        <MenuItem value={0}>0 mins</MenuItem>
                                        <MenuItem value={15}>15 mins</MenuItem>
                                        <MenuItem value={30}>30 mins</MenuItem>
                                        <MenuItem value={45}>45 mins</MenuItem>
                                        <MenuItem value={60}>60 mins</MenuItem>
                                        <MenuItem value={90}>90 mins</MenuItem>
                                        <MenuItem value={120}>
                                            120 mins
                                        </MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} pl={"9px !important"}>
                                <InfoTooltip
                                    title={`Static buffer put in automatically between bookings – this is replaced by the "Max travel time" setting if Smart Clusters optimization is enabled`}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} />
                            <Grid item xs={12} sm={3} />
                        </Grid>
                        <Grid item variant="subHeading">
                            <Typography variant="largerSubHeading">
                                Accept / Decline
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        {!companyIsSoleOperator() && (
                            <Grid item xs={12} sm={12}>
                                <FormControlLabel
                                    className={
                                        isFeatureGated(
                                            subscriptionLevel,
                                            "ProviderAcceptance"
                                        )
                                            ? classesnew.marginFeatureGateCustom
                                            : classesnew.marginBottomNone
                                    }
                                    onClick={() => {
                                        if (
                                            isFeatureGated(
                                                subscriptionLevel,
                                                "ProviderAcceptance"
                                            )
                                        ) {
                                            setShowFeatureGateDialog(true);
                                        }
                                    }}
                                    control={
                                        <Switch
                                            checked={providerMustAcceptAppt}
                                            disabled={isFeatureGated(
                                                subscriptionLevel,
                                                "ProviderAcceptance"
                                            )}
                                            onChange={(event) => {
                                                if (event.target.checked) {
                                                    if (providerAgnosticFlow)
                                                        setProviderAgnosticFlow(
                                                            false
                                                        );
                                                    if (canClientReschedule)
                                                        setCanClientReschedule(
                                                            false
                                                        );
                                                } else if (
                                                    !event.target.checked
                                                ) {
                                                    setBookingStates(
                                                        (prevState) => {
                                                            return {
                                                                ...prevState,
                                                                showProviderAcceptance: false
                                                            };
                                                        }
                                                    );
                                                }
                                                setProviderAgnosticFlow(false);

                                                setProviderMustAcceptAppt(
                                                    event.target.checked
                                                );
                                            }}
                                            value="active"
                                            color="primary"
                                            inputProps={{
                                                "aria-label": "primary checkbox"
                                            }}
                                        />
                                    }
                                    label={
                                        isFeatureGated(
                                            subscriptionLevel,
                                            "ProviderAcceptance"
                                        ) ? (
                                            <Grid
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1
                                                }}
                                            >
                                                <Typography>
                                                    Provider must accept
                                                    bookings
                                                </Typography>
                                                <StarsIcon color="notice" />
                                            </Grid>
                                        ) : (
                                            "Provider must accept bookings"
                                        )
                                    }
                                />
                                <InfoTooltip title="Providers must manually accept or decline any new booking request by email or SMS, or via the admin console or mobile app – if off, bookings will be auto-confirmed as soon as they are made" />
                            </Grid>
                        )}
                        {!companyIsSoleOperator() && DisplayProviderTimeout()}
                    </Grid>
                )}
                {tabValue === 2 && (
                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        <Grid item>
                            <Typography variant="largerSubHeading">
                                Emails
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant="outlined"
                                    id="replyemail"
                                    label="Client's email replies sent to"
                                    value={replyemailaddress}
                                    onChange={handleChangeReplyEmailAddress}
                                    size="small"
                                    width="50%"
                                />
                            </FormControl>
                            <InfoTooltip title="Reply-to email address for when clients respond to any auto-generated emails" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    value={chipsOrder}
                                    inputValue={orderSummaryBccList}
                                    onInputChange={(e, value) =>
                                        setOrderSummaryBccList(value)
                                    }
                                    onChange={(event, value) =>
                                        setChipsOrder(value)
                                    }
                                    sx={{
                                        "& .MuiAutocomplete-inputRoot": {
                                            minHeight: "fit-content",
                                            paddingTop: "4px !important",
                                            paddingBottom: "4px !important"
                                        }
                                    }}
                                    limitTags={5}
                                    onKeyDown={handleInputKeyDown}
                                    fullWidth
                                    clearIcon={false}
                                    multiple
                                    id="ac-bcc-list-1"
                                    options={[]}
                                    freeSolo
                                    renderTags={(value, getTagProps) =>
                                        value.map((chip, index) => (
                                            <Chip
                                                key={index}
                                                label={chip}
                                                variant="emailLabel"
                                                onDelete={() =>
                                                    removeChip(chip, "orderBcc")
                                                }
                                                sx={{
                                                    marginBottom: "0.25rem",
                                                    verticalAlign: "middle"
                                                }}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            id="bcc-list-1"
                                            variant="outlined"
                                            size="small"
                                            label="Receive all booking-related emails to"
                                        />
                                    )}
                                />
                            </FormControl>
                            <InfoTooltip title="Emails in this list will receive notifications for new bookings, reschedules and cancellations, as well as waitlist requests, provider availability updates and all other emails sent to admins – one email per line" />
                        </Grid>
                        {providerMustAcceptAppt && (
                            <>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            value={chipsOrderCreated}
                                            inputValue={bookingReqCreatedList}
                                            onInputChange={(e, value) =>
                                                setBookingReqCreatedList(value)
                                            }
                                            onChange={(event, value) =>
                                                setChipsOrderCreated(value)
                                            }
                                            onKeyDown={handleInputKeyDown}
                                            fullWidth
                                            clearIcon={false}
                                            multiple
                                            id="ac-orderCreated-emails"
                                            options={[]}
                                            freeSolo
                                            limitTags={5}
                                            sx={{
                                                "& .MuiAutocomplete-inputRoot":
                                                    {
                                                        minHeight:
                                                            "fit-content",
                                                        paddingTop:
                                                            "4px !important",
                                                        paddingBottom:
                                                            "4px !important"
                                                    }
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((chip, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={chip}
                                                        variant="emailLabel"
                                                        onDelete={() =>
                                                            removeChip(
                                                                chip,
                                                                "orderCreated"
                                                            )
                                                        }
                                                        sx={{
                                                            marginBottom:
                                                                "0.25rem",
                                                            verticalAlign:
                                                                "middle"
                                                        }}
                                                        {...getTagProps({
                                                            index
                                                        })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    id="orderCreated-emails"
                                                    variant="outlined"
                                                    size="small"
                                                    label="Receive all booking requests to"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <InfoTooltip title="Emails in this list will receive new booking requests to accept / decline, as well as notifications for any expired or declined booking requests – one email per line" />
                                </Grid>
                            </>
                        )}
                        <Grid item variant="subHeading">
                            <Typography variant="largerSubHeading">
                                Waitlist Match Notifications
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                style={{ marginBottom: "0px" }}
                                control={
                                    <Switch
                                        checked={waitlistMatchEnabled}
                                        onChange={(event) =>
                                            setWaitlistMatchEnabled(
                                                event.target.checked
                                            )
                                        }
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Send waitlist match notifications"
                            />
                            <InfoTooltip title="When a provider's schedule is created or updated, automatically check if any waitlist clients can now be served based on location coverage, and notify admins via email" />
                        </Grid>
                        {waitlistMatchEnabled && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth>
                                        <TextField
                                            variant="outlined"
                                            id="waitlist-lookback-months"
                                            label="Lookback window (months)"
                                            type="number"
                                            size="small"
                                            value={waitlistLookBackMonths}
                                            onChange={(e) => {
                                                const val = parseInt(
                                                    e.target.value,
                                                    10
                                                );
                                                setWaitlistLookBackMonths(
                                                    isNaN(val) || val < 1
                                                        ? 1
                                                        : val > 36
                                                          ? 36
                                                          : val
                                                );
                                            }}
                                            inputProps={{
                                                min: 1,
                                                max: 36
                                            }}
                                        />
                                    </FormControl>
                                    <InfoTooltip title="How far back (in months) to look for waitlist items when matching against new provider availability. Default is 6 months." />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            value={chipsWaitlistNotify}
                                            inputValue={waitlistNotifyInput}
                                            onInputChange={(e, value) =>
                                                setWaitlistNotifyInput(value)
                                            }
                                            onChange={(event, value) =>
                                                setChipsWaitlistNotify(value)
                                            }
                                            sx={{
                                                "& .MuiAutocomplete-inputRoot":
                                                    {
                                                        minHeight:
                                                            "fit-content",
                                                        paddingTop:
                                                            "4px !important",
                                                        paddingBottom:
                                                            "4px !important"
                                                    }
                                            }}
                                            limitTags={5}
                                            onKeyDown={handleInputKeyDown}
                                            fullWidth
                                            clearIcon={false}
                                            multiple
                                            id="ac-waitlist-notify-emails"
                                            options={[]}
                                            freeSolo
                                            renderTags={(value, getTagProps) =>
                                                value.map((chip, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={chip}
                                                        variant="emailLabel"
                                                        onDelete={() =>
                                                            removeChip(
                                                                chip,
                                                                "waitlistNotify"
                                                            )
                                                        }
                                                        sx={{
                                                            marginBottom:
                                                                "0.25rem",
                                                            verticalAlign:
                                                                "middle"
                                                        }}
                                                        {...getTagProps({
                                                            index
                                                        })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    id="waitlist-notify-emails"
                                                    variant="outlined"
                                                    size="small"
                                                    label="Send waitlist match emails to"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <InfoTooltip title="Emails in this list will receive waitlist match notifications when a provider's availability matches a waitlist client's location. If empty, notifications will be sent to the booking-related email list above." />
                                </Grid>
                            </>
                        )}
                        <Grid item variant="subHeading">
                            <Typography variant="largerSubHeading">
                                Schedule Change Notifications
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                style={{ marginBottom: "0px" }}
                                control={
                                    <Switch
                                        checked={scheduleChangeNotifyEnabled}
                                        onChange={(event) =>
                                            setScheduleChangeNotifyEnabled(
                                                event.target.checked
                                            )
                                        }
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Notify admins when a provider updates their schedule"
                            />
                            <InfoTooltip title="When a provider's schedule is created or updated, automatically send a notification email to admins with the updated availability details" />
                        </Grid>
                        {scheduleChangeNotifyEnabled && (
                            <>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            value={chipsScheduleChangeNotify}
                                            inputValue={
                                                scheduleChangeNotifyInput
                                            }
                                            onInputChange={(e, value) =>
                                                setScheduleChangeNotifyInput(
                                                    value
                                                )
                                            }
                                            onChange={(event, value) =>
                                                setChipsScheduleChangeNotify(
                                                    value
                                                )
                                            }
                                            sx={{
                                                "& .MuiAutocomplete-inputRoot":
                                                    {
                                                        minHeight:
                                                            "fit-content",
                                                        paddingTop:
                                                            "4px !important",
                                                        paddingBottom:
                                                            "4px !important"
                                                    }
                                            }}
                                            limitTags={5}
                                            onKeyDown={handleInputKeyDown}
                                            fullWidth
                                            clearIcon={false}
                                            multiple
                                            id="ac-schedule-change-notify-emails"
                                            options={[]}
                                            freeSolo
                                            renderTags={(value, getTagProps) =>
                                                value.map((chip, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={chip}
                                                        variant="emailLabel"
                                                        onDelete={() =>
                                                            removeChip(
                                                                chip,
                                                                "scheduleChangeNotify"
                                                            )
                                                        }
                                                        sx={{
                                                            marginBottom:
                                                                "0.25rem",
                                                            verticalAlign:
                                                                "middle"
                                                        }}
                                                        {...getTagProps({
                                                            index
                                                        })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    id="schedule-change-notify-emails"
                                                    variant="outlined"
                                                    size="small"
                                                    label="Send schedule change emails to"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <InfoTooltip title="Emails in this list will receive notifications when a provider creates or updates their schedule. If empty, notifications will be sent to the booking-related email list above." />
                                </Grid>
                            </>
                        )}
                        <Grid item variant="subHeading">
                            <Typography variant="largerSubHeading">
                                Reviews
                            </Typography>
                        </Grid>
                        <Grid item variant={"subHeading-divider"}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                style={{ marginBottom: "0px" }}
                                control={
                                    <Switch
                                        checked={sendratingTipMsg}
                                        onChange={(event) =>
                                            setSendratingTipMsg(
                                                event.target.checked
                                            )
                                        }
                                        value="active"
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Send clients a review request SMS"
                            />
                            <InfoTooltip title="When a booking is marked as completed, client will receive an SMS with a link to the review page, where they can rate the provider, write a review and leave a tip if they wish" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                style={{ marginBottom: "0px" }}
                                control={
                                    <Switch
                                        disabled={!sendratingTipMsg}
                                        checked={
                                            sendratingTipMsg && showTipOption
                                        }
                                        onChange={(event) =>
                                            handleChangeShowTipOption(event)
                                        }
                                        color="primary"
                                        inputProps={{
                                            "aria-label": "primary checkbox"
                                        }}
                                    />
                                }
                                label="Enable tip options on review page"
                            />
                            <InfoTooltip title="If off, clients will still be able to rate the provider and write a review, but they will not have the option to add a tip" />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl required fullWidth>
                                <TextField
                                    variant="outlined"
                                    id="ratingTipTextMsg"
                                    label="SMS content"
                                    size="small"
                                    multiline
                                    rows="5"
                                    value={ratingTipTextMsg}
                                    onChange={(e) =>
                                        setRatingTipTextMsg(e.target.value)
                                    }
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                )}
                {tabValue === 3 && (
                    <BookingFlowSettings
                        compId={state.id}
                        mode={state.mode === "Add" ? "Add" : "Edit"}
                        providerMustAcceptAppt={providerMustAcceptAppt}
                        timeSuggestionsEnabled={timeSuggestionsEnabled}
                        offersPackagesOnly={offersPackagesOnly}
                    />
                )}
                {tabValue === 4 && (
                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        {userHasMarketboxAdminRole() && (
                            <Grid item xs={12} sm={12}>
                                <FormControlLabel
                                    className={classesnew.marginBottomNone}
                                    control={
                                        <Switch
                                            checked={collectPayments}
                                            onChange={(event) => {
                                                setCollectPayment(
                                                    event.target.checked
                                                );
                                            }}
                                            value="collectPayments"
                                            color="primary"
                                            inputProps={{
                                                "aria-label": "primary checkbox"
                                            }}
                                        />
                                    }
                                    label="Accept payments on the MarketBox platform via Stripe"
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} sm={12}>
                            <StripeConnect
                                companyId={companyId}
                                stripeAccountId={stripeConnectedAccount}
                                setShowLoading={setShowLoading}
                                enabled={showStripeConnectButton()}
                                connected={
                                    stripeConnectedAccount &&
                                    stripeConnectEnabled
                                }
                            ></StripeConnect>
                        </Grid>

                        {!(stripeConnectedAccount && stripeConnectEnabled) && (
                            <Grid item xs={12} sm={12}>
                                {" "}
                                <Button
                                    variant="text"
                                    sx={{
                                        textTransform: "none",
                                        "&:hover": {
                                            backgroundColor: "transparent"
                                        }
                                    }}
                                    onClick={() =>
                                        setShowStripeConnectModal(true)
                                    }
                                >
                                    <Typography
                                        color="primary"
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: 14
                                        }}
                                    >
                                        Enter Stripe account credentials
                                        manually
                                    </Typography>
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                )}
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Grid display={"flex"} gap={"18px"}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={props.onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSaveCompany}
                        disabled={state.mode === "View" || isSubmitDisabled}
                    >
                        {state.mode === "Add" ? `Create company` : `Save`}
                    </Button>
                </Grid>
            </DialogActions>
        </>
    );
}
